package com.downdogapp.client

/**
 * AUTO-GENERATED DO NOT EDIT!
 * from com.downdogapp.tasks.AppStrings
 */
// @formatter:off 
object KoreanStrings : LanguageStrings {
  // https://worker.downdogapp.com/debug/appString?appStringId=488
  override fun ABBREVIATED_MEMBERSHIP_WILL_NOT_RENEW(p0: Any) = "${p0}에 만료되어 취소되었습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=498
  override val ACCOUNT = "계정"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2588
  override val ACCOUNT_INELIGIBLE_FOR_REFERRAL_MESSAGE = "이미 계정이 있는 것 같습니다! 새 계정만 추천을 통해 무료 회원이 될 수 있습니다. 죄송합니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3956
  override val ACTIVITY = "활동"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1467
  override val AFFILIATE_ANSWER = "관심을 가져 주셔서 감사합니다! 우리는 제휴 프로그램을 중단했으므로, 불행하게도 현재는 제공하고 있지 않습니다. 죄송합니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1466
  override val AFFILIATE_QUESTION = "추천 또는 제휴 프로그램이 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1299
  override val AFFORDABILITY = "가격 부담"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1300
  override val AFFORDABILITY_FEEDBACK_PROMPT = "현재 경제적인 어려움을 겪고 계신다면 저희에게 상황을 알려주세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=518
  override val AFFORDABILITY_MESSAGE = "Down Dog의 비전은 피트니스 앱을 합리적인 가격으로 세상에 제공하는 것입니다. Down Dog 구독 요금이 부담스러우시다면, 개인적인 상황을 설명하는 글을 보내주시면 저희가 조율해 드릴 수 있도록 알아보겠습니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3973
  override val AFFORDABILITY_SUPPORT_PAGE_TITLE = "비용이 부담되시나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3950
  override val AIRPLAY = "에어플레이"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1409
  override val AIRPLAY_ANSWER = "화면 미러링을 사용하여 Down Dog 연습을 AirPlay 하실 수 있습니다! 자세한 정보는 <a href=\"https://support.apple.com/en-us/HT204289\"> Apple 지원 페이지</a>에서 확인하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1408
  override val AIRPLAY_QUESTION = "AirPlay를 지원합니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1292
  override val ALL = "전체"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1255
  override val ALL_APPS = "모든 앱"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1453
  override val ALL_APPS_PURCHASE_ANSWER = "현재 구독 구매를 통해 Down Dog Yoga, HIIT, Barre 및 Prenatal Yoga를 포함한 모든 앱에 액세스 할 수 있습니다!\n\n현재 단일 앱 구매 옵션을 제공하지 않습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1452
  override val ALL_APPS_PURCHASE_QUESTION = "제 구독권으로 하나의 앱, 아니면 모든 앱을 이용할 수 있나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3110
  override val ALL_POSES = "모든 자세"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1295
  override fun AMOUNTS_CURRENCY_PAYMENTS_SECURE_MESSAGE(p0: Any) = "모든 금액은 ${p0}로 표시됩니다. 귀하의 결제 데이터는 암호화되어 안전합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=113
  override val AND = "과(와)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1589
  override val APPLE = "애플 (Apple)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1403
  override val APPLE_HEALTH_ANSWER = "네! 연결하는 데 문제가 있는 경우 시도하실 수 있는 몇 가지 팁이 있습니다.\n1. 앱이 건강 앱에 연결되어 있는지 확인하십시오. 앱을 실행하고 메뉴로 이동합니다 (오른쪽 하단의 햄버거 모양 버튼을 누르십시오). 애플 건강 앱에 연결하는 옵션이 나타나면 해당 옵션을 클릭하십시오.\n2. 모바일에서 건강 앱을 열고 데이터 소스 탭을 클릭하십시오. 다운독이 데이터 소스로 표시됩니까? 다운독이 연동되어 있는지 재확인하는 단계입니다. 연동되어 있지 않은 경우 (다운독에서 건강 앱과 연동하기 옵션이 없는 경우에) 저희에게 알려주십시오!\n3. 다운독 앱을 제거했다가 다시 설치하신 후, 다시 로그인하시고 애플 건강 앱에 다시 연결하십시오.\n\n죄송하지만 애플 건강 앱은 iPad에서는 지원되지 않으며, 여러 대의 장치에서 동시에 귀하의 수련을 기록하는 기능을 지원하고 있지 않습니다. (이 기능은 계획중에 있습니다)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1402
  override val APPLE_HEALTH_QUESTION = "Apple 건강 앱에 연동됩니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1420
  override fun APPLE_REFUND_POLICY(p0: Any) = "죄송하지만 앱스토어를 통해 구입하신 경우 Apple 정책에 따라, 저희가 귀하의 구독을 취소하거나 환불할 수 없습니다. 구독 취소 방법에 대한 Apple의 지침은 다음과 같습니다.: ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1425
  override val ASK_IN_FACEBOOK_GROUP = "페이스북 그룹에 문의하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=490
  override val AUTO_RENEW_IS_OFF = "자동 갱신 해제하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=489
  override val AUTO_RENEW_IS_ON = "자동갱신 설정"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1221
  override val AUTO_RENEW_OFF_ANSWER = "<b> 구독 관리 또는 취소 방법 </b>\n\n<em> 웹사이트 </em>에서 구독을 구매하신 경우 :\n1. <b> 설정 </b>으로 이동하십시오. 모바일에서는 화면 오른쪽 하단에있는 3 개의 선을 탭하여 이동하실 수 있습니다. 웹에서 설정은 왼쪽 사이드바에 있습니다.\n2. <b> 설정 </b>에서 <b> 구독 </b>을 누릅니다.\n3. 그러면 자동 갱신 해지를 포함하여 구독 취소 또는 변경 방법을 포함한 추가 정보가 표시됩니다.\n\n<em>모바일 앱을 통해 </em> 구독하신 경우 <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">애플 앱스토어</a> 또는 <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">구글 플레이 스토어</a> 를 통해 고객님의 구독을 관리하실 수 있습니다.\n\n<b> 고객님의 구독 정보 </b>\n\n당사의 웹사이트나 애플 또는 구글을 통해 멤버십을 구매하지 않으신 경우 구독 요금은 절대 청구되지 않습니다. 귀하의 구독권은 구독을 구입하실 때 사용하신 이메일 계정에서 확인하실 수 있습니다. 해당 계정에 구독이 표시되지 않으면 현재 로그인하신 이메일 계정에서 구매하신 구독권이 없는 것입니다. 귀하의 다른 이메일 주소 계정을 통해 구매하셨을 수도 있으며, 이 경우 구독 여부를 확인하려면 로그아웃 하신 후 해당 계정으로 로그인해야 합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1211
  override val AUTO_RENEW_OFF_QUESTION = "자동 갱신을 비활성화하고 싶습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=252
  override val BACK = "뒤로 가기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=787
  override val BARRE = "Barre (발레핏)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=759
  override val BARRE_GOOGLE_FIT_DESCRIPTION = "Barre (발레핏) 운동"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1432
  override val BILLING = "과금"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1258
  override val BILLING_REFUND = "청구 - 환불"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=332
  override val BREATHING = "호흡"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2538
  override val BREATHING_GOOGLE_FIT_DESCRIPTION = "호흡 연습"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=263
  override val CANCEL = "취소"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2564
  override val CANCEL_DOWNLOAD = "다운로드 취소"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1470
  override val CANNOT_MERGE_ACCOUNTS_ANSWER = "죄송하지만 계정을 통합할 수 없습니다.\n\n구독권을 구매하실 때 사용한 이메일로 로그인하여 앱을 이용하십시오!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1469
  override val CANNOT_MERGE_ACCOUNTS_QUESTION = "여러 개의 계정이 있습니다. 계정을 통합할 수 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1305
  override val CANT_ACCESS_SUBSCRIPTION_ANSWER = "실수로 Down Dog 계정을 여러 개 만들었습니다. 앱에서 로그아웃하고 사용했을 수 있는 다른 이메일 주소로 다시 로그인해야 합니다. 구독은 당사의 모든 앱과 모든 기기(웹 버전 포함)에서 작동하지만 구매에 사용한 것과 동일한 이메일로 로그인해야 합니다. <em>Apple, Google 및 PayPal에서 귀하가 Down Dog에 로그인할 때 사용한 이메일 주소가 아니라 해당 서비스와 연결된 이메일 주소로 영수증을 발송했을 수 있습니다</em>.\n\nApple iTunes 또는 Google Play를 사용하여 모바일 앱 내에서 구독한 경우 앱 메뉴에서 <b>인앱 구매 복원</b>을 클릭해야 합니다. 원래 구매한 동일한 앱 내에서 이 작업을 수행해야 합니다.\n\nPayPal을 통해 구독했는데 구독에 액세스할 수 없는 경우 결제에 실패했을 가능성이 큽니다. PayPal 계정 내에서 또는 며칠만 지속되는 구독이 표시되는 앱의 설정을 방문하여 이를 확인할 수 있습니다. 이 경우 실제로 청구되지 않았으며 당사 웹사이트를 방문하여 다시 구매를 시도할 수 있습니다. PayPal을 사용하는 것보다 신용 카드로 직접 지불하는 것이 더 성공적일 수 있습니다.\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1304
  override val CANT_ACCESS_SUBSCRIPTION_QUESTION = "구독권에 액세스할 수 없습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3949
  override val CAST = "전송"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1203
  override val CAST_ANSWER = "네, 다운독은 모바일과 웹 버전에서 크롬캐스트 지원을 시작하였습니다!\n\n모바일 앱에서 크롬캐스트를 사용하는 방법은 다음과 같습니다.\n1. 크롬캐스트 지원 기기(TV 등)의 전원이 켜져 있는지 확인하시고 고객님의 안드로이드 또는 iOS 기기와 동일한 WiFi 네트워크에 연결합니다. 모바일 앱이 최신 버전으로 업데이트 되어 있는지 확인하세요.\n2. 수련을 시작하세요.\n3. 화면을 탭하여 컨트롤 기능을 표시한 후 오른쪽 상단의 <b> 크롬캐스트 버튼 </b>을 선택합니다 (하단 모서리에 세개의 1/4원이 있는 사각형 아이콘).\n4. 수련이 TV에 전송되기까지 최대 1분 정도 기다리신 다음, 안드로이드 또는 iOS 장치에서 재생을 누르세요.\n\n웹앱에서 크롬캐스트를 사용하는 방법은 다음과 같습니다.\n1. 크롬캐스트 지원 기기(TV 등)의 전원이 켜져 있는지 확인하신 뒤 컴퓨터와 동일한 Wi-Fi 네트워크에 연결하세요.\n2. <b> 크롬</b>을 사용하여 웹 버전의 수련을 시작합니다.\n3. 오른쪽 하단의 <b> 크롬캐스트 버튼 </b>을 선택합니다 (하단 모서리에 세개의 1/4원이 있는 사각형 아이콘).\n4. 수련이 TV에 전송되기까지 최대 1분 정도 기다리신 다음, 컴퓨터에서 재생을 누르세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1191
  override val CAST_QUESTION = "크롬캐스트 지원이 됩니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1349
  override val CAST_TROUBLESHOOTING_ANSWER = "<b>캐스팅 버튼이 표시되지 않는 경우:</b>\n\n1. 수련을 시작한 다음 일시 중지합니다. 캐스팅 버튼 (Android / iOS 기기의 경우 오른쪽 상단, 웹 앱의 경우 오른쪽 하단)이 표시됩니까? 캐스팅 버튼은 수련 도중에만 표시됩니다.\n\n2. 같은 기기에서 다른 앱(예: YouTube)을 캐스팅 해보세요. 캐스팅 버튼이 표시됩니까? 그렇지 않은 경우 크롬캐스트 지원 기기 (예: TV)가 켜져 있는지, 컴퓨터 또는 Android / iOS 기기와 동일한 WiFi 네트워크에 연결되어 있는지 확인하십시오. 컴퓨터를 사용하실 경우 크롬 브라우저를 사용하십시오.\n\n3. 다른 장치를 사용하시어 캐스팅 해보십시오. Android / iOS 기기를 사용하는 경우 컴퓨터의 웹 버전에서 캐스팅해보시고, 웹 버전을 사용하시는 경우 Android / iOS 장치로 캐스팅 해보십시오.\n\n4. 모바일에서 Down Dog 앱의 배터리 최적화를 끄십시오. 이 방법으로 몇 분 동안 활동이 없으면 절전 모드로 전환되지 않고 앱을 크롬캐스트 지원 기기와 계속해서 연결할 수 있습니다.\n\n\n<b>'연결'은 되지만 동영상이 재생되지 않는 경우:</b>\n\n먼저 Down Dog이 TV에 로드되기까지 기다립니다. 로드하는 데 최대 60 초가 걸릴 수 있습니다. 이때 TV 하단에 노란색 \"로딩\"바가 표시되었다가 검은색으로 바뀝니다. 로드가 끝나면 TV에 영상이 재생됩니다.\n\n60초 후에도 TV 화면이 여전히 검은색이거나 검은 화면 가운데에 \"Down Dog\"라는 단어가 나타나면 수련을 종료하신 후 다시 시도하십시오. 히스토리 탭 (Android / iOS의 경우 화면 하단, 웹 버전에서는 왼쪽 사이드바에 있는 시계 아이콘)에서 동일한 수련을 다시 시작할 수 있습니다.\n\n\n<b>재생 후 몇 분 뒤에 캐스트 연결이 끊기는 경우:</b>\n\n1. WiFi 신호 강도를 확인하십시오. 크롬캐스트 또는 모바일/컴퓨터의 와이파이 신호가 약한 경우 WiFi 확장기를 사용하시거나, 라우터와 더 가까이 이동하여 신호 강도를 증가시킬 수 있습니다.\n\n2. 모바일에서 Down Dog 앱의 배터리 최적화를 끕니다. 이 방법으로 몇 분 동안 활동이 없으면 절전 모드로 전환되지 않고 앱을 크롬캐스트 지원 기기와 계속해서 연결할 수 있습니다.\n\n3. 그래도 문제가 해결되지 않으면 라우터를 다시 시작해보십시오.\n\n4. 마지막으로, 모바일 저장된 Wi-Fi 연결 설정을 변경하여 고정 IP 주소를 사용해보십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1348
  override val CAST_TROUBLESHOOTING_QUESTION = "크롬캐스트에 문제가 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=997
  override fun CASTING_TO_DEVICE(p0: Any) = "${p0}에 캐스트하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3302
  override val CHALLENGE_EMAIL_NOTIFICATIONS_TEXT = "이메일"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3470
  override val CHALLENGE_EMAIL_UPDATES_TEXT = "이메일"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3468
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBHEADER = "챌린지 업데이트"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3469
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBTEXT = "커뮤니티와 당신의 챌린지 진행 상황에 대한 업데이트를 받아보세요!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3466
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBHEADER = "매일 알림"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3467
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBTEXT = "1월 매일 연습할 수 있도록 알림을 받으세요!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3809
  override val CHALLENGE_FAQ_A1 = "A: 챌린지를 완료하려면 한 달 동안 매일 연습을 완료해야 합니다. 어떤 Down Dog 앱이든 사용할 수 있습니다. 연습은 완전히 완료되어야 합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3811
  override val CHALLENGE_FAQ_A2 = "A: Down Dog은 앱의 여정 페이지에 있는 달력을 사용하여 귀하의 진행 상황을 추적합니다! 매일 연습할 때 달력 날짜가 파란색으로 표시되면 도전 과제 진행 상황에 반영됩니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3814
  override val CHALLENGE_FAQ_A3 = "A: 저희는 전날 연습한 시간을 기준으로 매일 알림을 보냅니다. 그래서 평소보다 일찍 연습하셨다면 저희보다 먼저 하셨을 수도 있어요! 여정 페이지의 달력에 연습 기록이 표시되면 도전 과제 진행에 포함됩니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3816
  override val CHALLENGE_FAQ_A4 = "A: 아니요. 죄송하지만 Down Dog 앱에서 완료되지 않은 연습을 기록에 추가할 수 없습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3818
  override val CHALLENGE_FAQ_A5 = "A: 여행 중이거나 시간대를 변경하는 경우, 이는 도전 과제 연속 기록에 영향을 미칠 수 있습니다. 현재, 저희 시스템은 연습 당시의 시간대를 기준으로 연습 기록을 저장합니다. 이는 연습 날짜가 원래 시간대가 아닌 현재 시간대와 일치한다는 것을 의미합니다. 연속 기록을 유지하려면 가능한 한 원래 시간대에 맞춰 연습하는 것을 권장합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3820
  override val CHALLENGE_FAQ_A6 = "A: 우승자는 챌린지를 완료한 사용자 그룹에서 무작위로 선정됩니다. 우승자는 챌린지 종료 시 개별적으로 연락을 받습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3808
  override val CHALLENGE_FAQ_Q1 = "Q: 요구 사항은 무엇인가요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3810
  override val CHALLENGE_FAQ_Q2 = "Q: 내 진행 상황은 어떻게 추적되나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3813
  override val CHALLENGE_FAQ_Q3 = "Q: 매일 알림을 받도록 등록했는데 오늘은 알림을 받지 못했습니다. 문제가 있는 건가요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3815
  override val CHALLENGE_FAQ_Q4 = "Q: 다른 곳에서 연습을 완료했습니다. 내 앱 기록에 추가할 수 있나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3817
  override val CHALLENGE_FAQ_Q5 = "Q: 챌린지 기간 동안 여행을 가는데, 문제가 될까요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3819
  override val CHALLENGE_FAQ_Q6 = "Q: 상품 당첨자는 어떻게 선정되고 연락을 받나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3807
  override val CHALLENGE_FAQ_TITLE = "다운독 챌린지 FAQ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3465
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TEXT = "모든 커뮤니케이션을 받지 않기로 선택하셨으므로, Down Dog의 챌린지에 대한 진행 상황 업데이트나 알림을 받지 못하게 됩니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3471
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TITLE = "정말로 하시겠습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3303
  override val CHALLENGE_PUSH_NOTIFICATIONS_TEXT = "푸시 알림"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3317
  override val CHALLENGE_RESUBSCRIBE_TO_EMAILS_ALERT_TEXT = "주의하세요! 이전에 Down Dog에서 이메일 소통을 수신 거부하셨습니다. 챌린지 내에서 이메일 소통을 활성화하면, 자동으로 귀하의 계정이 다시 우리로부터 이메일 소통을 받을 수 있도록 활성화됩니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1218
  override val CHANGE_EMAIL_ANSWER = "1. <b> 설정 </b>으로 이동하십시오. 모바일에서는 화면 오른쪽 하단에 있는 3개의 수평선을 탭하여 이동할 수 있습니다. 웹 버전의 설정은 왼쪽 사이드 바에 있습니다.\n2. <b> 계정 </b> 에서 <b> 이메일 </b>을 누르고 사용하시려는 이메일을 입력하십시오.\n3. <b> 저장 </b>을 누릅니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1208
  override val CHANGE_EMAIL_QUESTION = "계정과 관련된 이메일을 어떻게 변경합니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=152
  override val CHANGE_LANGUAGE = "언어 변경하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1159
  override val CHANGE_LANGUAGE_ANSWER = "<b>요가, 임산부 요가, 명상, HIIT</b>\n\n언어를 변경하려면 <b>설정</b>으로 이동하십시오(모바일 앱에서는 오른쪽 하단의 3개의 수평선을 탭하고, 웹 앱에서는 설정이 왼쪽 사이드바에 있습니다) 그리고 <b>언어</b>를 탭하십시오!\n\n<b>바레</b>\n\n현재 이 앱은 영어로만 제공됩니다. 언어를 변경한 후에도 여전히 영어로 지시사항을 들을 수 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=327
  override val CHANGE_LANGUAGE_NO_INTERNET_MESSAGE = "이런! 언어를 변경 하려면 인터넷에 연결해야 합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1158
  override val CHANGE_LANGUAGE_QUESTION = "음성 지시 언어를 어떻게 변경합니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1219
  override val CHANGE_PASSWORD_ANSWER = "1. <b> 설정 </b>으로 이동하십시오. 모바일에서는 화면 오른쪽 하단에있는 3개의 수평선을 탭하여 이동할 수 있습니다. 웹 버전에서 설정은 왼쪽 사이드 바에 있습니다.\n2. <b> 계정 </b>에서 <b> 비밀번호 </b>를 누르고 비밀번호 및 비밀번호 확인 필드에 사용하실 새 비밀번호를 입력하십시오.\n3. <b> 저장 </b>을 누릅니다.\n\n비밀번호를 잊어 버린 경우, 로그인 화면에 이메일과 잘못된 비밀번호를 입력하십시오. 다음 <b> 비밀번호를 잊어버리셨습니까? </b> 옵션을 선택하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1209
  override val CHANGE_PASSWORD_QUESTION = "비밀번호는 어떻게 변경합니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1142
  override val CHANGE_PLAYLIST_TYPE_ANSWER = "다운독은 다양한 장르의 음악을 제공하며 지속적으로 새로운 음악을 추가하고 있습니다! 앱에서 시작 페이지를 위로 스와이프하여 <b>음악</b>을 탭하시면 음악 스타일을 변경하실 수 있습니다! 웹 버전에서는 설정 페이지에서 스크롤하여 <b>음악</b> 옵션을 클릭하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1141
  override val CHANGE_PLAYLIST_TYPE_QUESTION = "음악은 어떻게 변경합니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=52
  override val CHANGE_VISUAL_TYPE_NO_INTERNET_MESSAGE = "이런! 수련을 위해 영상을 변경 하시려면 인터넷 연결이 필요합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1157
  override val CHANGE_VOICE_ANSWER = "<b>요가, 임산부 요가, 명상, 그리고 HIIT</b>\n\n현재 이러한 앱에서는 여러 영어로 말하는 목소리를 제공하고 있습니다. 모바일에서는 메인 설정 페이지에서 위로 스와이프하여 듣는 목소리를 변경할 수 있으며, 그런 다음 <b>목소리</b>를 탭합니다. 웹에서는 설정을 스크롤하고 <b>목소리</b> 옵션을 클릭할 수 있습니다.\n\n또한 이러한 앱에서는 여러 비영어로 말하는 목소리를 제공합니다. <b>설정</b>으로 이동하여 언어를 변경할 수 있습니다(모바일 앱에서는 오른쪽 하단의 3개의 수평선을 탭하고, 웹 앱에서는 설정이 왼쪽 사이드바에 있습니다) 그리고 나서 <b>언어</b>를 탭하세요!\n\n<b>바레</b>\n\n현재는 한 가지 목소리만 제공하고 있지만, 앞으로 추가 언어와 목소리를 추가할 계획입니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1156
  override val CHANGE_VOICE_QUESTION = "목소리는 어디서 변경합니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1441
  override val CHARGED_TWICE = "이중으로 결제되었습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1433
  override fun CHECK_OUT_QUESTION(p0: Any) = "${p0} 에서 귀하의 질문에 대한 답변이 있는지 확인하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=482
  override val CLEAR_PRACTICE_HISTORY_CONFIRM_MESSAGE = "히스토리에서 모든 수련을 삭제 하시겠습니까? 이 작업은 되돌릴 수 없습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=275
  override val CLOSE = "닫기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1180
  override val COMMUNITY_ANSWER = "페이스북에서 도움이 될 수 있는 <a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\">Down Dog 커뮤니티</a>에 가입하시어 조언을 구하시고 고객님의 도전을 공유해 보세요!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1172
  override val COMMUNITY_QUESTION = "요가 커뮤니티가 필요합니다! 질문이 있을 때 도움을 받을 수 있는 곳이 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1394
  override val COMPANIES_FREE_UNTIL_JUNE_1_LONG = "재택 근무 직원은 6월 1일까지 무료 이용하실 수 있습니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2563
  override val CONFIRM_CANCEL_OFFLINE_DOWNLOAD = "이 다운로드를 취소하시겠습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2561
  override val CONFIRM_DELETE_OFFLINE_PRACTICE = "이 오프라인 연습을 삭제하시겠습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=428
  override val CONFIRM_PASSWORD = "비밀번호를 확인해주세요"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1
  override val CONNECT_TO_APPLE_HEALTH = "Apple 건강 앱에 연결하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=93
  override val CONNECT_TO_GOOGLE_FIT = "Google 피트니스에 연동하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2
  override val CONNECTED_TO_APPLE_HEALTH_MESSAGE = "요가 수련이 자동으로 Apple 건강 앱에 기록됩니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=94
  override val CONNECTED_TO_GOOGLE_FIT_MESSAGE = "수련이 자동으로 Google Fit 에 기록됩니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1009
  override val CONNECTING_TO_CHROMECAST = "연결중입니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=25
  override val CONNECTION_PROBLEM = "연결 문제 발생"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=264
  override val CONTACT = "연락하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1421
  override val CONTACT_APPLE_FOR_REFUND = "환불을 원하시는 경우 Apple 지원에 연락하시어 저희로부터는 환불 허가를 받았음을 알려주십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=265
  override val CONTINUE = "계속 하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=437
  override val CORPORATE_MEMBERSHIP = "법인 회원권"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=616
  override val COUNTDOWN_TIMER = "카운트 타이머"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2550
  override val CREATE_OFFLINE_PRACTICE = "오프라인 연습 만들기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2562
  override val CREATE_OFFLINE_PRACTICE_EXPLANATION = "현재 설정으로 실습을 생성하고 다운로드하시겠습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1604
  override val CUSTOM = "커스텀"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=266
  override val DELETE = "삭제하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=399
  override val DELETE_ACCOUNT = "계정 삭제하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=487
  override val DELETE_ACCOUNT_AND_STOP_PAYMENTS_CONFIRM_MESSAGE = "귀하의 계정은 Down Dog의 모든 앱에서 영구적으로 삭제되며, 구독은 자동으로 취소됩니다. 진행 하시겠습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1220
  override val DELETE_ACCOUNT_ANSWER = "Down Dog 사용을 중단하시는 경우 모바일 앱 또는 웹 버전에서 계정을 삭제하실 수 있습니다. 한번 계정이 삭제되면 복원 할 수 없으며 히스토리와 저장된 수련은 모두 삭제됩니다.\n\n1. <b>설정</b>으로 이동하십시오. 모바일에서 화면 오른쪽 하단에 있는 3개의 수평선을 탭하여 이동할 수 있습니다. 웹 버전에서 설정은 왼쪽 사이드바에 있습니다.\n2. <b>설정</b>에서 <b>내 정보</b>까지 스크롤 다운하시어 <b>계정 삭제 하기</b>를 탭하십시오.\n3. 팝업 상자가 나타나면 <b>네</b>를 누르십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=485
  override val DELETE_ACCOUNT_CONFIRM_MESSAGE = "계정을 삭제하시겠습니까? 삭제 시 되돌리기 할 수 없습니다. 귀하의 계정은 다운독의 모든 앱에서 완전히 폐기됩니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1210
  override val DELETE_ACCOUNT_QUESTION = "계정은 어떻게 삭제합니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1556
  override val DELETE_ACCOUNT_RECONFIRM_MESSAGE = "귀하의 모든 Down Dog 계정을 완전히 삭제하려고 합니다. 삭제 후에는 되돌릴 수 없습니다. 계속 하시겠습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=486
  override val DELETE_ACCOUNT_WITHOUT_STOPPING_PAYMENTS_CONFIRM_MESSAGE = "귀하의 계정은 Down Dog의 모든 앱에서 영구적으로 삭제됩니다. 또한 구독을 취소하시기 전까지는 구독 요금이 청구됩니다. 진행 하시겠습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=467
  override val DELETE_HISTORY = "수련 내역 삭제하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2565
  override val DELETE_OFFLINE_PRACTICE = "오프라인 실습 삭제"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1351
  override val DEVICE_LIMIT_ANSWER = "네, 구독하실 때 사용한 이메일을 사용하시어 로그인하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1306
  override val DEVICE_LIMIT_QUESTION = "구독 시 모든 장치(노트북, 휴대폰, 태블릿 등)에서 액세스할 수 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1501
  override val DIDNT_PURCHASE_SUBSCRIPTION = "구독권을 아직 구매하지 않았습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3946
  override val DISLIKE = "싫어요"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1502
  override val DONT_SEE_SUBSCRIPTION = "제 구독권이 보이지 않습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=629
  override val DOWNLOAD = "다운로드"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2557
  override val DOWNLOAD_EXPLANATION = "다운로드가 완료되면 오프라인 실습 페이지에서 이 실습을 찾을 수 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2559
  override val DOWNLOAD_PRACTICE = "다운로드 연습"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2556
  override val DOWNLOAD_STARTED = "다운로드 시작됨"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2555
  override fun DOWNLOADING_VIDEO_PROGRESS(p0: Any) = "다운로드 중... ${p0}%"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3947
  override val EDIT = "편집"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=491
  override val EDIT_EMAIL = "이메일 수정하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=628
  override val EDIT_NAME = "이름 수정하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=492
  override val EDIT_PASSWORD = "비밀번호 수정하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=462
  override val EMAIL = "이메일"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=137
  override val EMAIL_AND_PASSWORD = "이메일 및 비밀번호"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=197
  override val ENGLISH_POSE_NAMES = "영어 자세 이름"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3370
  override fun ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_INSTRUCTIONS(p0: Any) = "1. 설정 앱을 엽니다.\n\n2. 알림으로 이동합니다.\n\n3. ${p0} 앱을 찾고 <b>알림이 활성화되어 있는지</b> 확인하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3304
  override val ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_PROMPT = "당신의 모바일 기기에서 Down Dog의 푸시 알림이 활성화되어 있는지 확인하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=146
  override val ENTER_CODE = "코드를 입력하세요"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=138
  override val ENTER_EMAIL_ADDRESS = "이메일 주소 입력"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=139
  override val ENTER_PASSWORD = "암호를 입력하세요"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2170
  override val EQUIPMENT = "장비"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=88
  override val ERROR_CONNECTING_TO_APPLE_HEALTH_MESSAGE = "이런! 건강 앱에 연결하는 중에 오류가 발생했습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=56
  override val ERROR_CONNECTING_TO_GOOGLE_FIT_MESSAGE = "이런! Google Fit에 연결하는 중에 오류가 발생했습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=57
  override val ERROR_OCCURRED_MESSAGE = "오류가 발생했습니다. 고객 센터로 지원 문의하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1198
  override val EXCLUDE_POSES_ANSWER = "<b>HIIT (고강도인터벌트레이닝)</b> \n\n네! 수련 탭에서 <b>믹스</b>를 선택하세요. 각 신체 부위 왼쪽의 +를 누르면 운동 목록이 표시됩니다. 운동에서 제외하시려는 동작을 선택하세요.\n\n <b>요가, 임산부 요가, Barre (발레핏)</b> \n특정 동작 제외 기능은 현재 준비중에 있습니다. 모바일 앱에서 원하지 않는 포즈가 나오면 <b>왼쪽으로 스와이프</b>하여 건너뛰세요. 웹 버전에서는 화면 왼쪽 하단의 <b>오른쪽 화살표</b>를 클릭하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1187
  override val EXCLUDE_POSES_QUESTION = "수련 중 특정한 자세를 제외하기 할 수 있나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1262
  override val EXERCISE_ADVICE = "운동에 대한 조언"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1602
  override val EXERCISE_LIST = "동작 목록"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3254
  override val EXERCISE_NAMES = "운동 이름"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=267
  override val EXIT = "나가기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=268
  override val EXIT_PRACTICE = "수련 종료"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=156
  override val EXIT_PRACTICE_MESSAGE = "현재 수련을 끝내시겠습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2720
  override val EXPLICIT_LYRICS = "노골적인 가사"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=280
  override val FACEBOOK = "페이스북"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=58
  override val FACEBOOK_AUTHENTICATION_FAILURE_MESSAGE = "페이스북 인증 실패. 나중에 다시 시도하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=147
  override val FACEBOOK_COMMUNITY = "페이스북 커뮤니티"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2552
  override val FAILED_PRACTICE_DOWNLOAD = "실습을 다운로드하지 못했습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2568
  override val FAILED_PRACTICE_DOWNLOAD_EXPLANATION = "이 실습을 다운로드하는 중에 문제가 발생했습니다. 다시 시도해 주세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1308
  override val FAMILY_SHARING_ANSWER = "안타깝게도, 저희는 Apple Family Sharing을 지원하지 않습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1307
  override val FAMILY_SHARING_QUESTION = "가족과 구독을 공유하기 할 수 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1434
  override val FAQ_PAGE = "FAQ 페이지"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=269
  override val FAVORITE = "즐겨찾기에 추가"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=278
  override val FAVORITES = "즐겨찾기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1261
  override val FEATURE_REQUEST = "기능 요청"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2153
  override val FEEDBACK_OPTIONAL = "피드백(선택 사항)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1274
  override val FEEDBACK_SUBMITTED_TEXT = "피드백을 보내주셔서 감사합니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2553
  override val FETCHING_PRACTICE = "연습 만들기..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1417
  override val FITBIT_ANSWER = "아니요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1416
  override val FITBIT_QUESTION = "FitBit에 연동할 수 있나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3957
  override val FOR_YOU = "추천 콘텐츠"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=140
  override val FORGOT_PASSWORD = "비밀번호를 잊으셨나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=461
  override val FORGOT_PASSWORD_NEEDS_EMAIL = "비밀번호를 재설정하시려면 이메일을 입력하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1291
  override val FREE_FOR_HEALTHCARE_WORKERS = "의료진을 위한 무료 액세스"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1110
  override val FREE_FOR_SCHOOLS = "학교를 위한 무료 액세스"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1395
  override val GET_COMPANIES_MEMBERSHIP = "무료 법인 멤버십에 가입하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1393
  override val GET_HEALTHCARE_MEMBERSHIP = "의료진을 위한 무료 멤버십에 가입하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1392
  override val GET_STUDENT_MEMBERSHIP = "학생을 위한 무료 멤버십에 가입하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1463
  override val GIFT_ANSWER = "아니요. 현재 이 기능을 제공하지 않습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3823
  override val GIFT_INSTRUCTIONS_CONTENT_1 = "Down Dog 선물(또는 선물들!)을 구매하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3824
  override val GIFT_INSTRUCTIONS_CONTENT_2 = "인쇄하거나 친구 및 가족에게 보낼 수 있는 기프트 증서를 받으세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3825
  override val GIFT_INSTRUCTIONS_CONTENT_3 = "수령인은 준비가 되면 언제든지 인증서에 있는 QR 코드를 사용하여 1년간의 이용을 시작할 수 있습니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3780
  override val GIFT_INSTRUCTIONS_TITLE = "작동 방식:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1462
  override val GIFT_QUESTION = "구독권을 선물하기 할 수 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1440
  override val GO_TO_APPLE_SUPPORT = "Apple 지원으로 이동하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1519
  override val GOAL_STREAK_CAPITALIZED = "목표 연속 달성"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1514
  override val GOAL_STREAK_NOT_CAPITALIZED = "목표 연속 달성"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=281
  override val GOOGLE = "구글"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=60
  override val GOOGLE_AUTHENTICATION_FAILURE_MESSAGE = "Google 인증 실패. 나중에 다시 시도하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1401
  override val GOOGLE_FIT_ANSWER = "유감스럽게도 우리는 더 이상 Google Fit을 지원하지 않습니다.\n\nGoogle에서 몇 가지 변경사항을 도입하여 Google Fit을 우리의 제공 서비스에 계속 통합하는 것이 매우 어렵게 되었습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1400
  override val GOOGLE_FIT_QUESTION = "구글 핏에 앱을 연동할 수 있나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1495
  override val GUIDED_MEDITATION_AND_BREATHING_ANSWER = "<b>요가:</b>\n\n<em>요가 니드라를 시도해보세요</em>\n\n<b>요가 니드라</b>는 요가 앱의 연습 <b>유형</b>에서 찾을 수 있습니다.\n\n참고: 요가 니드라는 <b>오디오 전용</b>입니다 - 비디오는 없습니다.\n\n많은 사람들이 앱에서 <b>음악</b>을 자연 소리, 앰비언트, 브레인 웨이브 또는 피아노와 현악으로 설정하는 것을 즐깁니다. 몇 가지를 시도해보고 어떤 것을 선호하는지 알아보세요!\n\n요가 니드라가 처음이라면, <b>지시 유형</b>을 <b>전체 설명</b> 또는 <b>기본</b>으로 설정하여 들어보는 것을 추천합니다.\n\n또한 요가 니드라를 이용해 잠에 들 수도 있습니다. 요가 니드라를 연습 유형으로 선택한 후, <b>부스트</b>로 이동하여 <b>수면</b>을 탭하세요!\n\n\n<b>임산부 요가:</b>\n\n<b>부스트</b>를 <b>호흡</b>으로 설정하세요! 이렇게 하면 연습 시작 시 호흡 운동을 할 수 있고, 마지막에는 안내하는 명상을 할 수 있습니다!\n\n\n<b>명상:</b>\n\n우리는 명상과 호흡에 전념한 전체 앱을 가지고 있습니다! <a href='https://meditation.downdogapp.com/download'>명상</a>에서 확인해보세요!\n\n명상이 처음이라면, 가장 많은 지시를 받기 위해 설정 뷰를 위로 스와이프하고 <b>지도량</b>을 <b>많음</b>으로 설정하고, <b>가장 긴 침묵</b>을 짧은 시간인 30초 또는 1분으로 설정하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1494
  override val GUIDED_MEDITATION_AND_BREATHING_QUESTION = "수련 중 호흡과 명상에 대한 가이드를 더 자세히 받으려면 어떻게 해야 합니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=95
  override val HEALTH_DISCLAIMER_AND_WARNING = "건강 면책 및 경고"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=97
  override val HEALTH_WAIVER_TEXT = "* Yoga Buddhi Co.는 교육 목적에 한해 설계된 건강 및 피트니스 정보만을 제공합니다. 귀하는 Yoga Buddhi Co.의 응용 프로그램 (데스크톱, 모바일 및 장치 응용 프로그램, 웹 사이트, 블로그 및 Yoga Buddhi Co. 또는 Down Dog이 관리하는 모든 소셜 미디어 페이지를 포함하되 여기에 한정되지 않음)의 정보를 전문 의료 자문과 진단 또는 치료를 대신하여 의존해서는 안됩니다. 저희는 응용 프로그램의 콘텐츠의 정확성, 완전성과 유용성을 절대 보장하거나 보증하지 않습니다. Yoga Buddhi Co.에서 만든 응용 프로그램과 다른 모든 응용 프로그램에서 제공되는 정보의 사용은 전적으로 사용자 본인의 책임입니다. 우리는 기술을 연습하는 동안 발생한 부상에 대해 책임을 지지 않으며 Yoga Buddhi Co.는 모든 응용 프로그램에서 제안한 활동이나 아이디어로 인해 직간접적으로 발생할 수 있는 피해, 상황, 조건, 부상에 대한 책임을 지지 않습니다. 요가 연습에는 부상의 위험이 따릅니다. 임신중이거나 18세 미만인 경우 적절한 감독없이 요가 운동을 권장하지 않습니다. 귀하께서는 저희의 응용 프로그램을 사용함으로써 귀하의 건강, 그리고 귀하와 아기의 건강과 안위에 영향을 미칠 수 있는 후속적인 부상 또는 사고에 대한 모든 책임은 귀하에게 있음을 수락합니다. 피트니스 프로그램을 시작하기 전, 그리고 귀하의 건강에 관한 질문이나 우려가 있는 경우 의사나 전문 의료진과 상담하십시오. 의사나 전문 의료진이 운동을 권하지 않는 경우 피트니스 프로그램을 시작하지 마십시오. 운동 중 언제라도 기절, 현기증, 통증 또는 호흡 곤란이 발생하면 바로 중단하고 의사의 진료를 즉시 받아야 합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1391
  override val HEALTHCARE_FREE_UNTIL_JANUARY_1_LONG = "의료 서비스 제공자는 2022년 6월 1일까지 무료 멤버십을 이용할 수 있습니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1459
  override val HEALTHCARE_MEMBERSHIPS = "의료진을 위한 멤버십"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1753
  override val HERE_ARE_YOUR_SETTINGS = "고객님의 설정은 여기 있습니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=785
  override val HIIT = "HIIT"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=758
  override val HIIT_GOOGLE_FIT_DESCRIPTION = "인터벌 트레이닝 운동"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=282
  override val HISTORY = "히스토리"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1517
  override fun HOURS_SHORT(p0: Any) = "${p0} 시간"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1176
  override val HOW_MANY_INTRO_LESSONS_ANSWER = "인트로 버전에는 총 9개의 수업이 있습니다!\n \n<b>타입</b>을 누르면 빈야사, 하타, 원기회복 총 세 가지 요가 타입을 확인하실 수 있습니다.\n\n <b>타입</b>을 선택하고 숫자 (<b> 1, 2 , 3 </b>)를 눌러 해당 수업을 실행하실 수 있습니다. 수업 순서대로 번호를 지정하였으므로 1부터 시작하는 것이 좋습니다. 해당 번호를 선택하시면 동그라미가 흰색으로 변합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1168
  override val HOW_MANY_INTRO_LESSONS_QUESTION = "인트로 수업은 몇 회로 이루어져 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1475
  override val HOW_TO_CANCEL_ANSWER = "<b> 구독 관리 또는 취소 방법 </b>\n\n<em> 웹사이트에서 구독을 구매하신 경우 </em> :\n\n1. <b> 설정 </b>으로 이동하십시오. 모바일에서는 화면 오른쪽 하단에있는 3개의 선을 탭하면 이동할 수 있습니다. 웹사이트에서 설정은 왼쪽 사이드바에 있습니다.\n2. <b> 설정 </b>에서 <b> 구독 </b>을 누릅니다.\n3. 구독 취소 또는 자동 갱신 해지를 포함한 구독 변경 방법에 대한 추가 정보가 표시됩니다.\n\n<em> 모바일 앱을 통해 구독을 구매하신 경우 </em> :\n\n<a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">애플 앱스토어</a> 또는 <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">구글 플레이 스토어</a> 를 통해 고객님의 구독권을 관리하실 수 있습니다.\n\n<b> 고객님의 구독 정보 </b>\n\n당사의 웹사이트나 애플 또는 구글을 통해 멤버십을 구매하지 않으신 경우 구독 요금은 절대 청구되지 않습니다. 귀하의 구독권은 구독을 구입하실 때 사용하신 이메일 계정에서 확인하실 수 있습니다. 해당 계정에 구독이 표시되지 않으면 현재 로그인하신 이메일 계정에서 구매하신 구독권이 없는 것입니다. 귀하의 다른 이메일 주소 계정을 통해 구매하셨을 수도 있으며,이 경우 구독 여부를 확인하려면 로그아웃 하신 후 해당 계정으로 다시 로그인해야 합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1476
  override val HOW_TO_CANCEL_QUESTION = "구독을 취소하고 싶습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=99
  override val I_AGREE = "동의합니다"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1352
  override val I_HAVE_A_DIFFERENT_QUESTION = "다른 질문이 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1264
  override val I_HAVE_A_QUESTION_ABOUT = "질문 카테고리 :"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1383
  override val I_STILL_NEED_HELP = "도움이 더 필요합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1387
  override val I_WANT_A_REFUND = "환불하고 싶습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3292
  override val INCLUDE_POSES_ANSWER = "<b>요가</b> \n\n저희의 '좋아요' 및 '제외된 자세' 기능을 사용하면, 특정 자세를 '좋아요'로 표시하여 그 자세가 미래의 연습에서 더 자주 나타나게 할 수 있습니다. 전체 설정에서 <b>연습</b> 아래에 있는 <b>자세 보기</b>를 탭하세요. 여기서 연습에서 더 자주 보고 싶은 자세를 '좋아요'로 표시할 수 있습니다.\n\n<b>자세 보기</b>에서는 자세를 '싫어요'로 표시하여 미래의 연습에서 그 자세를 제외시킬 수도 있습니다.\n\n'좋아요' 및 '제외된 자세' 기능은 새로운 연습 유형인 비냐사, 복원력, 인, 젠틀, 하타에만 사용할 수 있다는 점을 유의해 주세요. 이전 연습 유형은 이 기능을 지원하지 않습니다.\n\n또한 자세를 좋아하거나 싫어하는 것이 다양성에 영향을 미칠 수 있다는 점을 유의해 주세요.\n\n\n<b>HIIT</b> \n\n네! 연습 아래에 있는 <b>믹스</b>를 탭하세요. 그런 다음 각 부위 왼쪽의 +를 탭하면 운동 목록이 나타납니다. 연습에서 제외하고 싶은 특정 운동을 탭하세요.\n\n\n<b>임산부, 바레</b>\n\n현재 이 기능은 제공하고 있지 않지만, 확실히 우리의 목록에 있습니다! 현재는 모바일 앱에서 좋아하지 않는 어떤 자세라도 나타날 때 왼쪽으로 스와이프하여 건너뛸 수 있습니다. 웹 앱에서는 화면 왼쪽 하단의 앞으로 화살표를 클릭하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3291
  override val INCLUDE_POSES_QUESTION = "제 연습에 특정 포즈를 포함시킬 수 있나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=155
  override val INSTAGRAM = "인스타그램"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=61
  override val INVALID_EMAIL_MESSAGE = "이메일 주소가 유효하지 않습니다. 다시 시도하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=161
  override val KEEP_TIMELINE_VISIBLE = "수련중 타임라인 표시하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=250
  override val LANGUAGE = "언어"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1426
  override val LATEST_PAYMENT = "귀하의 최근 결제 내역은 다음과 같습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1396
  override val LEARN_MORE = "더 알아보기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=168
  override val LENGTH = "길이"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=254
  override val LESS = "더 적게"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1179
  override val LEVEL_ANSWER = "모두가 같을 수는 없기 때문에 한 단계 높은 난이도를 체험하시고 그 느낌을 보실 수 있습니다. 어떤 날은 레벨을 낮추고 싶을 수도 있고, 또 때로는 새로운 단계를 시도해 보실 수도 있습니다! 항상 내 몸의 반응을 살펴보며 천천히 컨트롤하시면서 움직이는 것이 가장 중요합니다.\n\n앱의 <b> 설정 </b> 페이지를 통해 액세스 할 수있는 <a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\"> Facebook 커뮤니티 </a> 에서 다운독을 사용하는 다른 분들로부터 조언을 구하실 수 있습니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1171
  override val LEVEL_QUESTION = "언제 레벨을 올려야하나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=344
  override val LIFETIME = "평생"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1465
  override val LIFETIME_ANSWER = "아니요. 현재 이 기능을 제공하지 않습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1464
  override val LIFETIME_QUESTION = "평생 구독권을 구입할 수 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3945
  override val LIKE = "좋아요"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3047
  override val LIKE_OR_DISLIKE_EXPLANATION = "향후 연습을 개선하기 위해 자세를 좋아하거나 싫어하십시오"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3199
  override fun LIKED_DISLIKED_COUNT(p0: Any, p1: Any) = "${p0} 좋아요, ${p1} 싫어요"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2030
  override val LOCK_SCREEN_MEDIA_CONTROLS = "잠금 화면 미디어 컨트롤"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1729
  override val LOG_IN = "로그인"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1407
  override fun LOGGED_IN_AS(p0: Any) = "${p0} 로 로그인 하였습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=310
  override val LOGIN_ERROR = "로그인 오류"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=141
  override val LOGOUT = "로그 아웃"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=62
  override val LOGOUT_NO_INTERNET_MESSAGE = "인터넷에 연결되어 있지 않습니다. 계정을 전환하려면 인터넷에 연결하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1456
  override fun LOOK_SCHOOL_PAGE(p0: Any) = "귀하께서 학생 또는 교사인 경우 ${p0} 링크를 확인하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1227
  override val LOWER_VIDEO_QUALITY_ANSWER = "<b>더보기</b>에서 <b>영상 퀄리티</b>를 탭하시면 다양한 영상 유형으로 변경하실 수 있습니다. 고화질부터 저화질 비디오 옵션을 확인하실 수 있습니다. 이 설정은 요가 앱에서만 사용할 수 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1217
  override val LOWER_VIDEO_QUALITY_QUESTION = "동영상이 모바일 저장 용량을 너무 많이 차지하고 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2158
  override val MAKE_SURE_TO_VOTE_FOR_EVERY_OPTION = "모든 옵션에 투표하세요!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1486
  override val MANAGE_EMAIL_PREFERENCES_ANSWER = "너무 많은 이메일을 보내지 않으려 하지만 이메일은 고객님께 특별 할인 및 새로운 기능을 알릴 수 있는 기본 수단입니다!\n\n구독 여부와 상관 없이 <b> 설정 </b>으로 이동하신 후 아래로 스크롤하시어 <b> 프로모션 이메일 수신 </b>을 키거나 끄실 수 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1488
  override val MANAGE_EMAIL_PREFERENCES_QUESTION = "이메일 환경 설정은 어떻게 관리합니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1161
  override val MAXIMUM_VERBOSITY_ANSWER = "<b>요가 및 임산부 요가:</b>\n\n설정 뷰를 위로 스와이프하여 <b>지시사항</b>을 탭하면 말하는 양을 늘릴 수 있습니다. <b>전체</b>를 탭하면 우리가 제공하는 가장 많은 지시사항을 받을 수 있습니다.\n\n<b>명상:</b>\n\n우리가 제공하는 가장 많은 지시사항을 받으려면, <b>지도량</b>을 <b>가장 많음</b>으로 설정하고, <b>가장 긴 침묵</b>을 30초 또는 1분과 같은 짧은 시간으로 설정하세요.\n\n<b>HIIT 및 바레:</b>\n현재 HIIT 및 바레에서는 말하는 양을 변경하는 기능을 제공하지 않습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1160
  override val MAXIMUM_VERBOSITY_QUESTION = "동작을 연습할 때 최대한 많은 가이드를 듣고 싶습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1661
  override val MEDITATION = "명상"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1672
  override val MEDITATION_GOOGLE_FIT_DESCRIPTION = "명상 수련"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1431
  override val MEMBERSHIP_DELAYED_START_ANSWER = "아니요. 구독권은 구매와 동시에 시작됩니다.\n\n무료 평가판을 사용하시는 경우 무료 평가판 기간이 끝난 후에 구매하기 하실 수 있습니다만, 저희가 특별 세일을 진행하는 경우, 세일가를 놓칠 수 있습니다. 어려운 결정이라는 것을 잘 알고 있습니다.\n\n특별 세일 진행 여부에 관계 없이 당사 웹사이트는 일반적으로 해당 기간에 가장 좋은 가격을 제공하므로 구매하시려는 경우 <a href=\"/purchase\">downdogapp.com/purchase</a> 로 이동하십시오. \n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1430
  override val MEMBERSHIP_DELAYED_START_QUESTION = "구독 시작 날짜를 연기할 수 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=148
  override val MENU = "메뉴"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1163
  override val MINIMUM_VERBOSITY_ANSWER = "<b>요가 및 임산부 요가:</b>\n\n설정 뷰를 위로 스와이프하여 대화량을 줄일 수 있습니다. 그런 다음 <b>지시사항</b>을 탭하십시오. 가장 적은 양의 지시를 받으려면 <b>최소</b>를 탭하십시오.\n\n<b>명상:</b>\n\n가장 적은 양의 지시를 받으려면 설정 뷰를 위로 스와이프하고 <b>지도량</b>을 <b>최소</b>로 설정하고, <b>가장 긴 침묵</b>을 5분 이상과 같은 더 긴 시간으로 설정하십시오!\n\n<b>HIIT 및 바레:</b>\n\n현재 HIIT 및 바레에서 대화량을 변경하는 기능은 제공하지 않습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1162
  override val MINIMUM_VERBOSITY_QUESTION = "수련에 완전히 빠져들기 위해 최소한의 지시만을 듣기를 원합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=309
  override fun MINUTES(p0: Any) = "${p0} 분"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1254
  override fun MINUTES_SHORT(p0: Any) = "${p0} 분"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1610
  override val MINUTES_WITHOUT_NUMBER = "분"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1554
  override val MIRROR_VIDEO = "거울 영상"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3
  override val MISSING_APPLE_HEALTH_PERMISSIONS_MESSAGE = "애플 건강 앱에 Down Dog가 소스로 추가되었습니다. 요가 수련을 건강 앱에 등록하시려면 건강 앱 내에서 Down Dog에 대한 Workouts 권한을 활성화 해야 합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1583
  override val MIX = "믹스"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1510
  override val MONDAY = "월요일"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=519
  override val MONTH = "월"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=377
  override val MONTHLY = "월간"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1290
  override val MONTHLY_CAPITALIZED = "월간"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1511
  override val MONTHLY_PRACTICES = "월별 수련"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1516
  override fun MONTHLY_TIME(p0: Any) = "${p0} 수련 시간"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1513
  override val MONTHLY_TIME_PRACTICED = "월별 수련 시간"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1482
  override val MONTHLY_TO_YEARLY_ANSWER = "월간 구독권을 구매하신 후 연간 구독권으로 전환하시길 희망하는 경우에는 구매하신 방법에 따라 몇 가지 단계를 거쳐야 합니다.\n\n<em> <b> 웹사이트 </b> 또는 <b> 구글 플레이 </b> </ em>를 통해 구매하신 경우 :\n\n현재 사용하시는 구독권을 웹사이트에서 구매하신 경우 <b> 설정 </b>으로 이동 한 다음 <b> 구독 </b>으로 이동하여 현재 구독을 취소하십시오. 구글 플레이를 통해 구매하신 경우 <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">구글 플레이 스토어</a> 를 통해 구독을 취소하실 수 있습니다. 현재 사용하고 있는 구독권을 취소하신 후에 <a href=\"/purchase\"> 웹사이트를 통해 새 구독을 구매하기 </a> 할 수 있습니다.\n\n구독을 취소하고 재구매하시는 경우 부분 환불은 불가합니다. 일부 한정적인 경우에 현재 사용하고 있는 구독권에 대한 금액을 환불받을 수 있습니다. <a href=\"/support\"> 지원 </a>에서 \"환불을 원합니다\"를 클릭하여 환불 대상을 확인할 수 있습니다. <a href=\"/support\"> 지원 </a>의 \"환불을 원합니다\"에서 환불 대상을 확인하고 성공적으로 환불 요청 및 환불 확인을 받은 경우 현재 이용하시는 구독이 자동으로 취소됩니다. 그 다음 <a href=\"/purchase\"> 웹사이트를 통해 구독을 새로 구매하기 </a> 하실 수 있습니다.\n\n<em> <b> 애플 </b> </ em>을 통해 구독을 구매하신 경우 :\n\n<a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">through the 애플 앱스토어</a> 를 통해 구독을 취소해야 합니다. Apple을 통한 구매하신 경우 환불을 불가합니다. Apple에서 현재 구독을 취소하신 후 <a href=\"/purchase\"> 웹사이트를 통해 구독을 새로 구매하기 </a> 하실 수 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1481
  override val MONTHLY_TO_YEARLY_QUESTION = "월간 구독권을 이미 구입하였는데 연간 구독권으로 전환하고 싶습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=276
  override val MORE = "더 보기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=182
  override val MUSIC = "음악"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1140
  override val MUSIC_VOLUME_VS_VOICE_ANSWER = "수련을 시작한 다음, 화면을 탭하여 일시 중지하시면 <b> 음악/목소리 믹싱 슬라이더 </b>를 사용하여 음악과 목소리의 음량을 조절하실 수 있습니다.\n\n원하시는 음악/목소리 비율을 설정하신 다음 고객님의 장치에서 전체 볼륨을 높이거나 낮추실 수 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1139
  override val MUSIC_VOLUME_VS_VOICE_QUESTION = "강사의 목소리가 들리지 않습니다! 볼륨 컨트롤은 어디에 있나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=400
  override val MY_DATA = "내 정보"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=429
  override val NEED_INTERNET_FOR_SONG_PREVIEW_MESSAGE = "이런! 음악을 미리보기 하려면 인터넷에 연결하여야 합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3587
  override val NEW_PASSWORD = "새 비밀번호"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=9
  override val NEXT = "다음"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=403
  override val NEXT_PAYMENT = "다음번 결제"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=483
  override fun NEXT_PAYMENT_SUBTEXT(p0: Any) = "다음 결제 : ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1499
  override val NIDRA_AUDIO_ONLY_ANSWER = "요가 니드라는 <b> 오디오 전용 </b> 수련입니다. 영상은 없습니다!\n\n요가 니드라는 완벽하게 릴렉스하실 수 있는 명상 가이드입니다. 수련 <b> 타입 </b>에서 맨 아래까지 스크롤 하시면 찾을 수 있습니다. 많은 분들께서 앱에서 <b> 음악 </b>을 자연의 소리, 배경음악, 뇌파 또는 피아노와 현악으로 설정하는 것을 선호하십니다.\n\n요가 니드라가 처음이신 경우 <b> 설명 </b>을 <b> 모든 설명 </b> 또는 <b> 기본 </b>으로 설정하여 청취하는 것이 좋습니다. 잠에 드실 때에도 요가 니드라를 사용하실 수 있습니다.\n\n요가 니드라로 수련 타입을 설정 후 <b> 부스트 </b>로 이동하여 <b> 수면 </b>을 선택하세요!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1498
  override val NIDRA_AUDIO_ONLY_QUESTION = "요가 니드라 수련은 영상이 없습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1472
  override val NO_EXCHANGE_FEES_ANSWER = "다운독은 환전 또는 변환 수수료를 청구하지 않지만 귀하의 은행은 수수료를 청구할 수도 있으므로 반드시 은행과 확인하시기 바랍니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1471
  override val NO_EXCHANGE_FEES_QUESTION = "환전 수수료가 청구됩니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=160
  override val NO_FACEBOOK_EMAIL_MESSAGE = "Facebook으로 로그인하려면 이메일 주소에 대한 액세스를 허용하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=162
  override val NO_HISTORY_TEXT = "아직 수련을 완료하지 않았습니다. 홈 화면으로 밀어내기 하여 첫 번째 수련을 시작하세요!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=63
  override val NO_INTERNET_MESSAGE = "서버와 통신하는 데 문제가 있습니다. 인터넷 연결을 확인하고 다시 시도하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1497
  override val NO_MUSIC_OFFLINE_ANSWER = "라이센스 제한으로 인해 오프라인 상태일 경우 음악은 저장된 즐겨찾기에 포함되지 않습니다.\n\n고객님의 음악을 재생하시려면 장치의 다른 앱을 통해 음악을 재생할 수 있습니다. 다운독의 음성 지시는 모바일 및 태블릿에서 최대 볼륨으로 기본 설정되어 있지만 Spotify/iTunes 등에서 나오는 음악 소리보다 약할 수 있습니다.\n\n이 경우, 외장 스피커를 사용하여 음악을 재생하시거나 노트북 또는 데스크톱에서 웹 버전 <a href=\"/web\"> downdogapp.com/web </a>을 사용하시고 모바일 장치로 음악을 낮은 볼륨으로 재생하시는 것을 권장드립니다.\n\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1496
  override val NO_MUSIC_OFFLINE_QUESTION = "오프라인 상태인데 즐겨찾기한 수련에는 음악이 없습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2551
  override val NO_OFFLINE_PRACTICES = "아직 다운로드한 사례가 없습니다. 기록에서 사례를 다운로드하거나 여기에서 새 사례를 만들 수 있습니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1478
  override val NO_PARTIAL_REFUND_ANSWER = "죄송하지만 부분 환불은 불가합니다.\n\n이미 구독권을 구입하신 후에 다른 구독권으로 전환을 원하시는 경우, 구매하신 경로에 따라 몇 가지 단계를 따라야 합니다.\n\n<em> <b> 웹사이트 </b> 또는 <b> 구글 플레이 </b>를 통해 구매한 경우 </em>:\n\n웹사이트를 통해 구독을 구매하신 경우 <b> 설정 </b>으로 이동 한 다음 <b> 구독 </b>으로 이동하여 현재 가입을 취소하십시오. 구글 플레이를 통해 구매하신 경우 <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">구글 플레이 스토어</a> 에서 구매하신 구독을 취소하실 수 있습니다. 구매하신 구독권을 취소하신 후 <a href=\"/purchase\"> 웹사이트를 통해 새 구독을 구입하기 </a> 하실 수 있습니다.\n\n구독권을 취소하신 후  다시 구매하실 경우 부분 환불은 불가합니다. 일부 한정된 경우에 현재 구독하신 금액에 대한 환불을 받으실 수 있습니다. <a href=\"/support\"> 지원 </a>에서 \"환불을 원합니다\"를 클릭하시면 환불 대상을 확인하실 수 있습니다. <a href=\"/support\"> 지원 </a>의 \"환불을 원합니다\"에서 환불 대상을 확인 후 환불 요청을 하시고 성공적으로 환불이 확인되면 현재 가입된 구독권이 자동으로 취소됩니다. 그 다음, <a href=\"/purchase\"> 웹 사이트를 통해 새 구독을 구입하기 </a> 할 수 있습니다.\n\n<em> <b> 애플 </b> </ em>을 통해 구매한 경우 :\n\n<a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\"> Apple App Store를 통해 </a> 구독을 취소 해야 합니다. Apple을 통한 구매하신 경우 저희는 환불해 드릴 수 없습니다. Apple을 통해 현재 구독을 취소하신 후에 <a href=\"/purchase\"> 웹 사이트를 통해 새 구독을 구매하기 </a> 할 수 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1477
  override val NO_PARTIAL_REFUND_QUESTION = "부분 환불을 받을 수 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=283
  override val NO_PAST_PURCHASES = "과거 구매 기록 없음"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=163
  override val NO_PAST_PURCHASES_MESSAGE = "아직 구매를 하지 않았습니다. 이미 구매하셨다면 Google에 문의하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1454
  override val NO_REFUND_PRACTICED = "구독권을 구입하신 후 수련을 하셨기 때문에 해당 결제 건은 환불할 수 없습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1455
  override fun NO_REFUND_TIME(p0: Any) = "결제가 ${p0} 일 전에 이루어졌기 때문에 환불할 수 없습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=164
  override val NO_SAVED_PRACTICES_TEXT = "즐겨찾는 수련을 저장하여 나중에 재생하거나 오프라인으로 연습 할 수 있도록 기기에 다운로드하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1224
  override val NO_SOUND_ANSWER = "앱에서 사운드를 켜기 위해 다음 방법을 시도해 보실 수 있습니다.\n\n• 장치 자체가 음소거되어 있지 않은지 확인하셨습니까? 기기 내의 다른 앱을 통해 음악 또는 오디오를 재생하시어 확인할 수 있습니다.\n• 인앱 볼륨이 켜져 있는지 확인하셨습니까? 수련을 시작하신 후, 연습을 일시중지한 다음 화면 하단 근처의 슬라이더를 조정하여 음악과 음성 볼륨의 균형을 조정하실 수 있습니다. 음악과 음성을 함께 들으시려면 중간 근처로 조정되어 있는지 확인하십시오!\n• 앱을 종료 후 다시 실행해보셨습니까?\n• 앱 제거 후  다시 설치해보셨습니까?\n• Down Dog 웹 버전 (<a href=\"https://www.downdogapp.com/web\" target=\"_blank\">https://www.downdogapp.com/web</a>)을 사용해 보셨습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1214
  override val NO_SOUND_QUESTION = "소리가 안나옵니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=10
  override val NO_STRING = "아니요"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1388
  override val NO_SUBSCRIPTIONS_SUPPORT_MESSAGE = "귀하의 계정에 유효한 구독권이 없습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=284
  override val NONE = "없음"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1483
  override val NOT_FREE_ANSWER = "2018년 9월, 우리는 모든 기능에 대한 전체 액세스를 제공하는 짧은 무료 체험 후 구독이 필요한 새로운 가격 모델로 전환했습니다. 이 가격 모델은 모든 앱에 적용됩니다.\n\n<b>구매 방법</b>\n\n<a href=\"/purchase\">웹사이트를 통한 구매</a>가 보통 가장 좋은 가격을 제공합니다! 웹사이트에서는 <b>신용카드</b>나 <b>PayPal</b>로 구매할 수 있습니다. 웹사이트를 통해 구매하면 Apple이나 Google을 통해 앱 내에서 구매한 것처럼 모든 앱의 모든 기능에 액세스할 수 있습니다.\n\n또한 Apple이나 Google을 통해 앱 내에서 구매할 수도 있습니다. Apple과 Google은 수수료를 부과하므로, 앱 내 가격이 웹사이트보다 보통 더 높을 수 있다는 점을 유의하세요.\n\n미국 외 지역에서 구매할 경우, 우리는 환전 수수료를 부과하지 않지만, 귀하의 은행에서 부과할 수 있으니 반드시 확인하세요!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1468
  override val NOT_FREE_QUESTION = "무료 앱인줄 알았는데 왜 구독권을 구매하라고 나오나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=285
  override val OK = "네"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1686
  override fun ONLY_MIX_GROUP(p0: Any) = "${p0}만"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=243
  override val OPEN_IN_AMAZON = "Amazon 에서 열기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=216
  override val OPEN_IN_ITUNES = "iTunes에서 열기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=32
  override val OPEN_IN_SPOTIFY = "Spotify 에서 열기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1257
  override fun OPEN_IN_X(p0: Any) = "${p0} 열기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3948
  override val OPEN_LINK = "링크 열기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2149
  override fun OPTION_X_OF_Y(p0: Any, p1: Any) = "${p1}의 옵션 ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=142
  override val OR = "또는"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1111
  override val OTHER = "기타"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1059
  override val OTHER_APPS = "다른 앱"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=194
  override val PACE = "속도"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=463
  override val PASSWORD = "비밀번호"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=68
  override val PASSWORD_LENGTH_MESSAGE = "비밀번호는 4자 이상 이어야합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=445
  override val PASSWORDS_MUST_MATCH = "비밀번호가 일치해야 합니다"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3944
  override val PAUSE = "일시정지"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=339
  override val PAY_WITH = "결제 수단"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=349
  override val PAY_WITH_PAYPAL = "PayPal로 결제하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=480
  override val PAYPAL = "PayPal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=347
  override val PAYPAL_AUTHORIZATION_ERROR_MESSAGE = "PayPal 구매를 승인하는 중에 오류가 발생했습니다. 몇 분 후에 다시 시도하거나 고객 지원팀에 문의하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1419
  override val PAYMENT_ALREADY_REFUNDED = "해당 결제는 이미 환불되었습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=165
  override val PAYMENT_CONFIRMED_MESSAGE = "결제 승인 완료!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1474
  override val PAYMENT_METHODS_ANSWER = "구독을 구매하는 방법은 다음과 같습니다.\n\n1) 웹사이트에서 <b>신용카드</b> 또는 <b>PayPal</b>로 구매할 수 있습니다.\n\nApple 또는 Google을 통해 인앱을 구매한 것처럼 당사 웹사이트를 통해 구매하면 모든 앱의 모든 것에 액세스할 수 있습니다. Apple/Google 수수료가 부과되지 않기 때문에 일반적으로 당사 웹사이트의 가격이 가장 좋은 가격입니다.\n\n2) Apple 또는 Google을 통해 인앱 구매가 가능합니다.\n\nApple과 Google은 수수료를 부과하므로 인앱 가격은 일반적으로 당사 웹사이트보다 높습니다.\n\n미국 이외의 지역에서 구매하는 경우 환전 수수료가 부과되지 않지만 은행에서 수수료를 청구할 수 있으므로 은행에 확인하십시오!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1473
  override val PAYMENT_METHODS_QUESTION = "사용할 수 있는 결제 수단에는 어떤 것이 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=465
  override val PAYMENT_PLAN = "플랜"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=317
  override val PER_MONTH = "매월"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=318
  override val PER_YEAR = "매년"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2539
  override val PILATES = "필라테스"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2549
  override val PILATES_GOOGLE_FIT_DESCRIPTION = "필라테스 운동"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3943
  override val PLAY = "재생"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=55
  override val PLAY_STORE_PRODUCT_PRICES_MESSAGE = "플레이 스토어에서 가격을 가져 오는 중 오류가 발생했습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=319
  override val PLAYLIST = "재생 목록"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=72
  override val PLAYLIST_TYPE_BUSY = "재생 목록 타입을 변경하는 중에 문제가 발생했습니다. 몇 초 후에 다시 시도하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=73
  override val PLAYLIST_TYPE_NO_INTERNET_MESSAGE = "인터넷에 연결되어 있지 않습니다. 음악 타입을 변경 하려면 인터넷에 연결하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3049
  override fun POSE_DISLIKED_MESSAGE(p0: Any) = "우리는 당신의 미래의 연습에서 ${p0}을 제외할 것입니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1199
  override val POSE_LIBRARY_ANSWER = "현재 동작 라이브러리는 개발 중에 있습니다! 조금만 기다려주세요!\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1188
  override val POSE_LIBRARY_QUESTION = "각 포즈에 대해 자세히 배울 수 있도록 하는 포즈 라이브러리가 있나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3048
  override fun POSE_LIKED_MESSAGE(p0: Any) = "우리는 당신의 미래의 연습에 더 많은 ${p0}을 추가할 것입니다"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1532
  override val POSE_LIST = "동작 목록"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3008
  override val POSE_LIST_DESCRIPTION = "아래의 모든 포즈를 탐색하고, 앞으로의 연습에서 더 많이 보거나 덜 보고 싶은 포즈를 지정하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3252
  override val POSE_NAMES = "포즈 이름"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3071
  override val POSES = "포즈"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=286
  override val PRACTICE = "수련"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1275
  override val PRACTICE_FEEDBACK = "수련 피드백"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=166
  override val PRACTICE_SAVED_CONFIRMATION = "수련이 즐겨찾기에 추가되었습니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1515
  override val PRACTICE_STREAK_NOT_CAPITALIZED = "연속 수련 성과"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1293
  override fun PRACTICES_IN_MONTH(p0: Any) = "${p0} 수련"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=456
  override val PRENATAL = "임산부 요가"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1200
  override val PRENATAL_ANSWER = "네! 고객님을 위한 임산부 요가 전용 앱이 있습니다! <a href=\"https://play.google.com/store/apps/details?id=com.downdogapp.prenatal&hl=ko_\"_blank\">Android</a> 및 <a href=\"hhttps://apps.apple.com/kr/app/%EC%9E%84%EC%82%B0%EB%B6%80-%EC%9A%94%EA%B0%80-down-dog-%EB%8B%A4%EC%9A%B4%EB%8F%85/id1504152442\"_blank\">iOS</a> 또는 <a href=\"https://prenatal.downdogapp.com/web\" target=\"_blank\">prenatal.downdogapp.com/web</a> 에서 임산부 요가앱을 다운받으실 수 있습니다. 임산부 요가는 산모의 임신 주기에 따라 맞춤 설정하실 수 있습니다. 또한 다운독 요가 앱이 제공하는 것과 동일한 부스트뿐만 아니라 임신과 관련된 특별한 부스트가 많이 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1189
  override val PRENATAL_QUESTION = "저는 임산부입니다! 사용할 수 있는 임산부 옵션이 있나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1267
  override val PRENATAL_SHORT = "산전"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2554
  override fun PREPARING_VIDEO_PROGRESS(p0: Any) = "동영상 준비 중... ${p0}% 완료"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2569
  override val PREPARING_VIDEO_WARNING = "동영상을 준비하고 있습니다. 다운로드가 시작될 때까지 앱을 열어 두거나 몇 분 후에 앱으로 돌아와 다운로드를 시작하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1405
  override val PRICE_DIFFERENCE_ANSWER = "<a href=\"/purchase\"> 웹사이트를 통한 구매하기 </a> 는 Apple 또는 Google 중개 수수료를 면제할 수 있어 일반적으로 가장 좋은 가격을 제공합니다! <b> 신용 카드 </b> 또는 <b> PayPal </b>을 통해 웹사이트에서 구입하실 수 있습니다. 웹사이트를 통해 구매하면 Apple 또는 Google을 통해 인앱을 구매 하신 것과 동일하게 모든 앱의 모든 기능을 이용하실 수 있습니다. 컴퓨터, 휴대 전화 및 태블릿에서도 웹사이트에서 구매하신 구독권을 사용할 수 있습니다.\n\nApple 또는 Google을 통해 인앱 구독을 구입할 수도 있습니다. Apple 및 Google의 중계 수수료 때문에 인앱 가격이 웹사이트보다 일반적으로 더 높은 점 참고 부탁드립니다.\n\n* 미국 이외의 지역에서 구매하실 경우, 저희는 환율 수수료를 부과하지 않지만 고객님의 은행은 부과할 수도 있으므로 반드시 은행과 확인하시기 바랍니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1404
  override val PRICE_DIFFERENCE_QUESTION = "인앱 가격이 웹사이트 가격과 다른 이유가 있나요? 멤버십 기능에 차이가 있나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=287
  override val PRIVACY_POLICY = "개인 정보 정책"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=398
  override val PROMOTIONAL_EMAILS = "프로모션 이메일 수신하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=351
  override fun RECEIPT_SENT_TO_EMAIL_MESSAGE(p0: Any) = "영수증이 ${p0} (으)로 전송됩니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1461
  override val RECEIPTS_ANSWER = "구독권을 구입하시면 구독하실 때 사용한 이메일로 영수증을 보내드립니다.\n\n유감스럽게도 영수증은 다시 보낼 수 없습니다. 원본 영수증을 찾으려면 메일함에서 제목 줄 \"<b> 귀하의 다운독 영수증 </b>\"을 검색해 보실 수 있습니다. 스팸함도 확인해 주세요!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1460
  override val RECEIPTS_QUESTION = "구매 영수증을 보내 주시겠습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3799
  override val REDEEM = "사용하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3798
  override fun REDEEM_GIFT_INSTRUCTIONS(p0: Any, p1: Any) = "아래 버튼을 클릭하여 Down Dog 1년 무료 이용권을 받으세요! 선물(코드 ${p0})은 선물을 교환한 날부터 ${p1} 계정에 적용됩니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3797
  override val REDEEM_GIFT_VIEW_TITLE = "다운독 기프트 카드 사용하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1222
  override val REFUND_ANSWER = "웹 버전에서 구독을 구매하신 경우 <a href=\"/support\">지원</a> 페이지를 통해 환불을 요청하실 수 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1212
  override val REFUND_QUESTION = "환불 방법은 어떻게 됩니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1424
  override val REFUNDED_ON_WAY = "환불을 진행하고 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=626
  override val REMOVE_FROM_FAVORITES = "즐겨찾기에서 삭제하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=625
  override val REMOVE_FROM_HISTORY = "히스토리에서 삭제하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=663
  override val REMOVE_FROM_HISTORY_MESSAGE = "정말 수련을 히스토리에서 삭제 하시겠습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1206
  override val RENAME_FAVORITES_ANSWER = "네! <b>즐겨찾기</b> 화면에서 <b>이름 편집하기</b>를 탭하시면 원하시는 대로 작성하실 수 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1194
  override val RENAME_FAVORITES_QUESTION = "마음에 드는 수련에 이름을 지정하여 관리할 수 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3421
  override fun REQUIRED_EMAIL_DOMAIN_ALERT(p0: Any) = "${p0} 도메인이 포함된 이메일 주소를 사용하여 로그인해 주세요!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1910
  override val RESET = "초기화"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=154
  override fun RESET_PASSWORD_MESSAGE(p0: Any) = "비밀번호 재설정 링크가 ${p0} (으)로 전송되었습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=167
  override val RESUME_PRACTICE = "수련 다시 시작하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=169
  override val RESUME_PRACTICE_MESSAGE = "이전에 하던 수련을 다시 시작 하시겠습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2245
  override val RUNNING = "달리기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2255
  override val RUNNING_GOOGLE_FIT_DESCRIPTION = "다운 도그 달리기 운동"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=66
  override val SAFARI_OR_MOBILE_BROWSER_WARNING_MESSAGE = "모바일 또는 태블릿에서 최상의 수련을 하시려면 App Store 또는 Play Store에서 앱을 다운로드하십시오. 데스크톱/노트북 컴퓨터에서는 Chrome을 사용하시면 가장 안정적으로 재생하실 수 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1480
  override val SALE_PRICE_ANSWER = "세일할 때마다 홈페이지를 통해 구매하셔야 할인된 가격으로 만나보실 수 있습니다.\n\n구매는 신용 카드 또는 PayPal을 사용하여 당사 웹사이트에서 할 수 있습니다. 국제 거래의 경우 환전 수수료가 부과되지 않지만 은행에서 수수료를 부과할 수 있으므로 반드시 확인하십시오!\n\n이미 구독을 구매했고 특별 할인을 이용하려면 현재 구매 방법에 따라 몇 가지 단계를 수행해야 합니다. 구독 구매는 구매 즉시 적용되며 현재 구독을 취소합니다. 현재 구독 종료 시 추가되지 않습니다.\n\n<em><b>웹사이트</b> 또는 <b>Google Play</b></em>를 통해 구매한 경우:\n\n웹을 통해 현재 구독을 구입한 경우 <b>설정</b>으로 이동한 다음 <b>구독</b>으로 이동하여 현재 구독을 취소합니다. Google Play를 통해 구매한 경우 <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank를 통해 현재 구독을 취소할 수 있습니다. \">Google Play 스토어</a>. 현재 구독을 취소한 후 당사 웹 사이트를 통해 새 구독을 구입할 수 있습니다.\n\n취소 및 재구매를 선택하면 부분 환불을 제공할 수 없습니다. 일부 제한된 상황에서 현재 구매에 대한 환불 자격이 있을 수 있습니다. <a href=\"/support\">지원</a>에서 \"환불을 원합니다\"를 클릭하여 환불 자격을 확인할 수 있습니다. 환불 자격이 있고 <a href=\"/support\">지원</a>의 \"환불을 원합니다\"에서 환불을 성공적으로 요청하고 확인을 받은 경우 현재 구독이 자동으로 취소됩니다. 그런 다음 웹 사이트를 통해 새 구독을 구입할 수 있습니다.\n\n<em><b>Apple</b></em>을 통해 구독을 구매한 경우:\n\n<a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">Apple App Store를 통해</a> 구독을 취소해야 합니다. Apple을 통한 구매에 대한 환불 요청은 수용할 수 없습니다. Apple을 통해 현재 구독을 취소한 후 일반적으로 가장 저렴한 가격으로 당사 웹 사이트를 통해 새 구독을 구입할 수 있습니다!\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1479
  override val SALE_PRICE_QUESTION = "할인 이메일을 받았습니다! 할인 가격은 어디서 확인하나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=198
  override val SANSKRIT_POSE_NAMES = "산스크리트어 자세 이름"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=454
  override val SAVE = "저장하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=529
  override val SAVE_AND_UNLINK = "저장 후 연결 해제하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1204
  override val SAVE_FOR_OFFLINE_ANSWER = "네! 오프라인 사용을 위해 연습을 저장하는 방법에는 세 가지가 있습니다. 이 방법은 웹이 아닌 모바일 앱에서만 가능합니다.\n \n1. <b> 즐겨찾기 </b> 화면에서 수련을 생성하고 저장하세요. 먼저 시작 화면 하단에있는 하트 아이콘을 탭하세요. <b> 즐겨찾기 </b> 페이지에 <b> 새 수련 다운로드 </b> 라는 큰 파란색 버튼이 표시됩니다. 이 탭을 누르면 현재 설정을 반영한 수련을 자동으로 다운로드합니다 (홈 화면에서 현재 설정 확인 가능). 장치에 저장되면 수련 이름 오른쪽에 아래쪽 화살표가 나타납니다. \n \n2. <b> 히스토리 </b> 에서 연습을 저장하세요. 먼저 <b> 히스토리 </b> 페이지로 이동하세요 (시작 화면 하단의 시계 아이콘을 탭하세요). 아래로 스크롤하시어 저장하시고자 하는 수련을 누릅니다. 하단에 <b> 즐겨찾기에 추가 </b> 라는 단어가 표시됩니다. 이 버튼을 누르면 오프라인 사용을 위해 수련을 <b> 즐겨찾기 </b>에 저장할 수 있습니다 (화면 하단의 하트 아이콘을 탭하여 <b> 즐겨찾기 </b> 에 저장되었는지 확인할 수 있습니다). 장치에 저장되면 수련 이름 오른쪽에 아래쪽 화살표가 나타납니다. \n \n3. 수련이 끝난 후 <b> 즐겨찾기에 추가하기 </b>를 누르세요. 이 버튼을 누르면 방금 연습한 수련이 <b> 즐겨찾기 </b> 페이지 (하단의 하트 아이콘)에 저장됩니다. 장치에 저장되면 수련 이름 오른쪽에 아래쪽 화살표가 나타납니다. \n\n저작권 문제로 인해 오프라인 상태에서는 즐겨찾기에 음악이 포함되지 않습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1192
  override val SAVE_FOR_OFFLINE_QUESTION = "Down Dog 앱을 오프라인에서 사용할 수 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1205
  override val SAVE_TO_FAVORITES_ANSWER = "네!\n\n<em>방금 완료한 연습 저장하기</em>\n\n방금 완료한 연습을 저장하고 싶다면, 연습 후 페이지에서 <b>즐겨찾기에 추가</b>를 탭하면 연습에 하트 아이콘을 추가하고 <b>즐겨찾기</b>에 저장합니다. <b>즐겨찾기</b>에 접근하려면, 메인 화면 하단의 시계 아이콘을 통해 접근 가능한 <b>기록</b> 페이지에서, 하트 아이콘이 있는 기록 중 어떤 연습이든 클릭하거나, <b>모두</b>에서 토글하여 <b>즐겨찾기</b>만 보실 수 있습니다.\n\n<em>기록에서 이전 연습 저장하기</em>\n\n이전에 한 연습을 저장하고 싶다면, 홈 화면 하단의 시계 아이콘을 탭하여 <b>기록</b> 페이지로 이동하세요. 그곳에 도착하면 아래로 스크롤하여 저장하고 싶은 연습을 탭하세요. 하단에 <b>즐겨찾기에 추가</b>라는 단어를 볼 수 있습니다. 그것을 누르면 연습을 <b>즐겨찾기</b>에 저장하고 연습에 하트 아이콘을 추가합니다. <b>즐겨찾기</b>에 접근하려면, <b>기록</b> 페이지에서, 하트 아이콘이 있는 기록 중 어떤 연습이든 클릭하거나, <b>모두</b>에서 토글하여 <b>즐겨찾기</b>만 보실 수 있습니다.\n\n<em>재미있는 사실!</em>\n\n기록에서 찾은 모든 연습(즐겨찾기인지 아닌지에 관계없이)에 라벨을 붙일 수 있습니다. 기록에서 연습을 탭하고 <b>이름 편집</b>을 선택하면 됩니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1193
  override val SAVE_TO_FAVORITES_QUESTION = "제가 좋아하는 수련을 저장할 수 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1458
  override val SCHOOL_MEMBERSHIPS = "학교 전용 멤버십"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2150
  override val SCORE = "점수"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2151
  override val SCORE_HATE_IT = "1 (싫어)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2152
  override val SCORE_LOVE_IT = "5 (좋아해)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3951
  override val SEARCH = "검색"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3108
  override val SEARCH_FOR_A_POSE = "자세 검색"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3286
  override val SEARCH_FOR_AN_EXERCISE = "운동을 검색하세요"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1601
  override val SEE_EXERCISES_ON_TIMELINE = "타임라인에서 동작 보기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1587
  override val SEE_POSES_ON_TIMELINE = "타임라인으로 동작 보기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=270
  override val SELECT = "선택하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=585
  override val SEND = "보내기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=149
  override val SEND_FEEDBACK = "피드백 보내기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1406
  override val SENDING_FEEDBACK_FAILED = "의견 보내기에 실패하였습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2747
  override val SEQUENCE_LENGTH_INVALID = "죄송합니다. 해당 연습 시간은 현재 설정으로는 불가능합니다. 다른 길이를 선택하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=297
  override val SET_PASSWORD = "비밀번호를 설정하세요"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=430
  override val SETTINGS = "설정"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1177
  override val SETTINGS_FOR_BEGINNERS_ANSWER = "<b>요가:</b>\n\n<em>레벨 설정</em>\n\n요가에 처음 접하는 경우, 연습 설정에서 찾을 수 있는 <b>초급 1</b> 레벨로 시작하는 것을 추천합니다.\n\n<em>연습 유형 선택</em>\n\n서 있는 자세와 바닥 자세를 포함하는 더 부드러운 연습을 원한다면, 연습 유형 <b>젠틀</b>을 시도해 보세요.\n\n오직 바닥 자세만을 포함하는 휴식 연습을 원한다면, <b>복원</b>이나 <b>인</b>을 시도해 보세요. 이들은 자세를 가장 오래 유지할 수 있게 해줍니다.\n\n더 빠르고, 흐르는 듯한, 에너지 넘치는 연습을 원한다면, <b>비냐사</b>를 시도해 보세요.\n\n더 적게 흐르고, 차투랑가를 생략하며, 자세를 더 오래 유지함으로써 열을 쌓고 싶다면, <b>하타</b>를 시도해 보세요.\n\n<em>지시 수준</em>\n\n가장 상세한 지시를 받기 위해 <b>지시</b> 수준을 <b>전체</b>로 설정하세요.\n\n<em>전환 속도와 유지 시간 설정</em>\n\n연습을 더 느리게 하고 싶다면, <b>전환 속도</b>를 <b>가장 느림</b>으로, <b>유지 시간</b>을 <b>가장 길게</b> 조정하는 것을 추천합니다. 이전 연습 유형은 이러한 기능을 지원하지 않는다는 점을 유의해 주세요.\n\n<em>워밍업과 쿨다운 연장</em>\n\n비냐사, 하타, 젠틀 연습 유형의 경우, <b>워밍업</b>과 <b>쿨다운</b>을 <b>연장</b>으로 조정하세요. 이전 연습 유형은 이러한 기능을 지원하지 않는다는 점을 유의해 주세요.\n\n<em>자세 좋아요 및 제외</em>\n비냐사, 하타, 젠틀 연습 유형에서는 \"좋아요\"를 눌러 자세를 더 자주 연습하거나 \"싫어요\"를 눌러 다시 보지 않을 수 있습니다.\n\n\n<b>임산부 요가:</b>\n\n요가에 처음 접하는 경우, 설정 보기에서 위로 스와이프하여 연습 설정에서 찾을 수 있는 <b>초급 1</b> 레벨로 시작하는 것을 추천합니다.\n\n휴식 연습을 원하는 경우, 모두 바닥 작업이며 자세를 가장 오래 유지할 수 있는 <b>복원</b>으로 시작하는 것을 추천합니다.\n\n\n<b>명상:</b>\n\n명상에 처음 접하는 경우, <b>가장 긴 침묵</b> 시간을 상당히 짧게 유지하는 것을 추천합니다 - 기본값은 2분이지만, 더 적은 침묵 시간과 더 많은 지도를 원한다면 30초까지 줄일 수 있습니다. 또한 <b>지도량</b>을 <b>가장 많음</b>으로 설정하여 우리가 제공하는 가장 많은 지시를 받을 수 있습니다!\n\n\n<b>HIIT</b>\n\n기본 설정은 시작하기에 좋은 곳입니다!\n\n레벨 1에서 HIIT가 너무 어렵다면, 레벨 0을 시도해 보세요! 각 운동에 더 짧은 시간을 할애하는 것도 시도해 볼 수 있습니다. 이는 설정 보기에서 위로 스와이프하여 연습 설정에서 운동 시간을 조정함으로써 가능합니다. 5초나 10초가 얼마나 큰 차이를 만들 수 있는지 놀랄 것입니다! 또한 전체 운동 시간을 줄이고 각 운동 사이의 회복 시간을 늘릴 수도 있습니다.\n\n<b>회전</b>과 <b>진행</b> 두 가지 연습 유형을 제공합니다. 항상 같은 순서로 몸의 다른 부분을 움직이려면 <b>진행</b>을 선택하거나, 다른 연습에서 순서를 섞어 몸의 다른 부분을 움직이려면 <b>회전</b>을 선택하세요!\n\n\n<b>바레:</b>\n\n운동 시간을 변경하여 난이도를 조정할 수 있습니다. 경험 많은 운동 선수들은 15분 또는 20분으로 시작하고, 추가적인 도전을 원한다면 점차 늘려나갈 수 있습니다. 만약 초보자라면, 매일 5분 또는 이틀에 한 번 10분으로 시작하는 것이 좋습니다. 꾸준히 하다 보면, 금방 더 긴 운동 시간에 대비할 수 있게 될 것입니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1169
  override val SETTINGS_FOR_BEGINNERS_QUESTION = "어디서부터 시작해야 할지 모르겠어요! 최고의 수련 경험을 위해서는 어떤 설정을 선택해야합니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1061
  override val SEVEN_MINUTE = "7분 운동"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=150
  override val SHARE = "공유하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1246
  override val SHARE_PRACTICE_ANSWER = "수련 직후 또는 <b>히스토리</b> 나 <b>즐겨찾기</b>에서 <b>수련 공유하기 </b>를 탭하시면 해당 연습을 친구들과 공유하실 수 있는 링크가 생성됩니다.\n\n받는 분께서 링크를 클릭하시면 앱으로 이동하여 공유할 수련에 대한 팝업 메시지가 표시됩니다. <b> 예 </b>를 탭하여 <b> 즐겨찾기 </b>에 저장하시면 됩니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1245
  override val SHARE_PRACTICE_QUESTION = "친구들과 수련 공유하기는 어떻게 하나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1181
  override val SHARE_THIS_PRACTICE = "수련 공유하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1235
  override val SHARED_PRACTICE = "공유된 수련"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3257
  override val SHOW_EXERCISE_NAMES = "운동 이름 표시"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3343
  override val SHOW_LIKE_AND_EXCLUDE_BUTTONS = "좋아요 및 제외 버튼 표시"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2085
  override val SHOW_OVERLAY = "'다음' 텍스트 표시"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2082
  override val SHOW_POSE_NAME = "동작 이름 표시"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1555
  override val SHOW_SUBTITLES = "자막 표시"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1728
  override val SIGN_UP = "회원가입"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=64
  override val SIGN_UP_LOGIN = "회원가입 / 로그인"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=271
  override val SKIP = "넘어가기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1173
  override val SLOWER_PACE_ANSWER = "<b>요가:</b>\n\n몇 가지 설정을 조정하여 연습을 느리게 할 수 있습니다 - 모두 실험해 보는 것을 추천합니다!\n\n<em>전환 속도</em>\n\n전체 설정을 보려면 위로 스와이프하세요. <b>타이밍</b> 아래에서 <b>전환 속도</b>를 탭하고 <b>가장 느림</b>으로 설정하여 한 자세에서 다른 자세로 전환하는 데 가장 많은 시간을 할애하도록 하세요, 그런 다음 <b>선택</b>을 탭하세요. 이 기능은 이전 연습 유형을 지원하지 않는다는 점을 유의해 주세요.\n\n<em>보유 길이</em>\n\n전체 설정을 보려면 위로 스와이프하세요. <b>타이밍</b> 아래에서 <b>보유 길이</b>를 탭하고 <b>가장 길게</b> 설정하여 각 자세에서 가장 많은 시간을 할애하도록 하세요, 그런 다음 <b>선택</b>을 탭하세요. 이 기능은 이전 연습 유형을 지원하지 않는다는 점을 유의해 주세요.\n\n<em>워밍업</em>과 <em>쿨다운</em>\n\n<b>워밍업</b>과 <b>쿨다운</b>을 <b>확장</b>으로 설정하세요. 이 기능은 이전 연습 유형을 지원하지 않는다는 점을 유의해 주세요.\n\n<em>지시 수준</em>\n\n가장 많은 지시와 팁을 얻으려면, <b>지시</b> 수준을 <b>전체</b>로 설정할 수도 있습니다.\n\n<em>연습 유형</em>\n\n연습 <b>유형</b>을 <b>진행형</b>이나 <b>하타</b>로 설정하여 비냐사 플로우/차투랑가를 생략해 보는 것도 좋습니다. 또는 더욱 천천히 진행하려면 연습 <b>유형</b>을 <b>인</b>이나 <b>복원</b>으로 설정하세요!\n\n<b>임신 요가:</b>\n\n설정 보기에서 위로 스와이프하고 <b>속도</b>를 <b>가장 느림</b>으로 설정하여 각 자세에서 가장 많은 시간을 보내세요. 가장 많은 지시와 팁을 얻으려면, <b>지시</b> 수준을 <b>전체 설명</b>으로 설정할 수도 있습니다.\n\n<b>HIIT:</b>\n\n각 운동에 소비하는 시간을 변경할 수 있습니다. 설정 보기에서 위로 스와이프하고 <b>연습</b> 아래에서 <b>운동 길이</b>를 탭하세요. 운동 사이의 휴식 시간도 <b>회복</b>을 탭하여 조정할 수 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1165
  override val SLOWER_PACE_QUESTION = "수련 속도를 늦출 수 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=466
  override val SOCIAL = "소셜"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2086
  override val SOMETHING_WENT_WRONG = "문제가 발생했습니다"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1533
  override val SONG_LIST = "노래 목록"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=288
  override val SONGS_PLAYED = "재생된 노래"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=272
  override val START = "시작"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1600
  override val START_PRACTICE = "수련 시작하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=89
  override val START_PRACTICE_NO_INTERNET_MESSAGE = "인터넷에 연결되어 있지 않습니다. 새로운 수련을 시작하려면 인터넷에 연결하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2090
  override val START_SHARED_PRACTICE = "이 공유 연습을 시작 하시겠습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1507
  override val STAT_TYPE_SUBTITLE = "어떤 옵션을 원하십니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1506
  override val STAT_TYPE_TITLE = "통계 기록을 선택하세요"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1390
  override val STUDENTS_FREE_UNTIL_JANUARY_1_LONG = "학생과 교사는 무료 회원 자격을 받을 수 있습니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1268
  override val SUBJECT_COLON = "제목:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=273
  override val SUBMIT = "제출"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1266
  override val SUBMITTING = "제출중"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=477
  override val SUBSCRIPTION = "구독"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1223
  override val SUBSCRIPTION_RENEWAL_PRICE_ANSWER = "네!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1213
  override val SUBSCRIPTION_RENEWAL_PRICE_QUESTION = "제가 구매했던 가격과 동일한 가격으로 구독을 갱신할 수 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1389
  override fun SUBSCRIPTIONS_SUPPORT_MESSAGE(p0: Any) = "${p0} 계정으로 로그인 했습니다. 이 계정의 구독권은 다음과 같습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1288
  override val SUBTITLES_ANSWER = "우리가 제공하는 모든 언어에 대한 자막/부제목이 사용 가능합니다!\n\n모바일 앱에서:\n1. 연습을 시작합니다\n2. 화면을 누르고, 그런 다음 <b>기어 아이콘</b>을 선택합니다. <b>자막 표시</b>를 <b>ON</b> 위치로 전환합니다\n\n웹 앱에서:\n1. 연습을 시작합니다\n2. 화면의 오른쪽 하단에 위치한 <b>cc</b> 아이콘을 클릭하여 텍스트 전사를 켭니다\n\n텍스트 전사를 끄려면, <b>cc</b>를 다시 누르면 됩니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1287
  override val SUBTITLES_QUESTION = "자막이 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=452
  override val SUCCESS = "성공"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1509
  override val SUNDAY = "일요일"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=500
  override val SUPPORT = "지원"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2333
  override val SUPPORT_MANAGE_EXPECTATIONS_TEXT = "우리는 매우 작은 회사이며 하루에 수천 개의 메시지를 수신하므로 응답을 약속할 수는 없지만 신속하게 회신할 수 있도록 최선을 다하겠습니다! 우리는 유료 고객의 메시지를 우선시합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1754
  override val SWIPE_DOWN_TO_START_PRACTICING = "아래로 내려 수련을 시작하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=262
  override val TAP_TO_BEGIN = "시작하려면 누르세요"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1260
  override val TECH_ISSUES = "기술적인 문제"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=289
  override val TERMS_OF_USE = "이용 약관"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=303
  override val THANKS = "고맙습니다"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2157
  override val THANKS_FOR_FILLING_OUT_THE_SURVEY = "설문조사를 작성해주셔서 감사합니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1265
  override val THIS_FORM_FIELD_IS_REQUIRED = "이곳을 작성해 주세요"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=615
  override val TIMELINE = "타임라인"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2050
  override val TOGGLE_SHOW_MORE_SETTINGS = "단추를 눌러 더 많은 설정을 확인합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2590
  override val TOO_MANY_DOWNLOADS = "최대 동시 다운로드 수에 도달했습니다. 완료될 때까지 기다린 후 다시 시도하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1248
  override val TOTAL_PRACTICES = "전체 수련 횟수"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1523
  override val TOTAL_PRACTICES_CAPITALIZED = "모든 수련"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1524
  override val TOTAL_PRACTICES_NOT_CAPITALIZED = "모든 수련"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1252
  override val TOTAL_TIME = "수련한 총 시간"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1521
  override val TOTAL_TIME_CAPITALIZED = "총 시간"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1522
  override val TOTAL_TIME_NOT_CAPITALIZED = "수련한 총 시간"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1137
  override val TROUBLESHOOTING = "트러블슈팅"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=251
  override val TRY_AGAIN = "다시 하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1155
  override val TURN_OFF_MUSIC_ANSWER = "앱 내 음악을 끄려면 설정 뷰를 위로 스와이프하고 <b>음악</b>을 탭한 다음, 음악 유형에 대해 <b>없음</b>을 탭하십시오!\n\n자신의 음악을 재생하려면 장치의 다른 앱을 통해 할 수 있습니다. 그러나 오디오 큐는 기본적으로 전화와 태블릿에서 최대 볼륨으로 설정되어 있지만, 때때로 이것이 Spotify/iTunes 등에서 나오는 소리를 압도하기에 충분하지 않습니다.\n\n이런 경우에는 음악을 재생하기 위해 외부 스피커를 사용하거나, 노트북이나 데스크탑에서 웹 버전(https://www.downdogapp.com/web)을 사용하고 배경에서 음악을 줄이는 것을 추천합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1154
  override val TURN_OFF_MUSIC_QUESTION = "수련 중에 제가 가지고 있는 음악을 듣고 싶습니다. 앱 음악을 종료하기는 어떻게 합니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2088
  override val UNABLE_TO_LOAD_PLAYBACK_URL = "죄송합니다. 동영상을로드 할 수 없습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1276
  override val UNABLE_TO_OPEN_LINKED_PRACTICE = "링크된 수련은 이 계정과 연동되어 있지 않습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=998
  override val UNKNOWN_CAST_RECEIVER_NAME = "알 수 없는 장치"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1641
  override val UNLINK_FROM_APPLE = "Apple 연결 해제하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1642
  override val UNLINK_FROM_APPLE_MESSAGE = "Apple 연결을 해제하시려면 비밀번호를 설정하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=504
  override val UNLINK_FROM_FACEBOOK = "Facebook 연동 해제하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=506
  override val UNLINK_FROM_FACEBOOK_MESSAGE = "Facebook 연동을 해제하시려면 비밀번호를 설정하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=505
  override val UNLINK_FROM_GOOGLE = "Google 연동 해제하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=507
  override val UNLINK_FROM_GOOGLE_MESSAGE = "Google 연동을 해제하시려면 비밀번호를 설정하세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1398
  override val UNLINK_GOOGLE_FACEBOOK_ANSWER = "1. <b> 설정 </b>으로 이동하십시오. 모바일에서는 화면 오른쪽 하단에있는 3개의 선을 탭하여 이동할 수 있습니다. 웹사이트에서 설정은 왼쪽 사이드바에 있습니다.\n2. <b> 계정 </b> 에서 <b> 구글 연동 해제하기 </b> (또는 <b> 페이스북 연동 해제하기 </b>)를 누르고 비밀번호 및 비밀번호 확인 시 사용하실 새 비밀번호를 입력하세요.\n3. <b> 저장 </b>을 누릅니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1397
  override val UNLINK_GOOGLE_FACEBOOK_QUESTION = "구글/페이스북 연결을 해제하는 대신 이메일과 비밀번호를 사용하려면 어떻게 합니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=418
  override val UPDATE = "업데이트"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1226
  override val VIDEO_ACCIDENTALLY_MIRRORED_ANSWER = "수련이 반대로 나온다면 미러링 기능이 켜져 있는지 확인하십시오! 확인하는 방법은 다음과 같습니다.\n\n모바일 앱에서 :\n1. 수련을 시작합니다.\n2. 화면 오른쪽 상단에서 <b>오른쪽에서 두번째 아이콘</b>을 눌러 디스플레이를 뒤집습니다.\n\n웹 버전에서 :\n1. 수련을 시작합니다.\n2. 화면 오른쪽 하단에서 <b>왼쪽에서 세번째 아이콘</b>을 클릭하시어 디스플레이를 뒤집습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1216
  override val VIDEO_ACCIDENTALLY_MIRRORED_QUESTION = "영상과 음성의 방향이 반대입니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1225
  override val VIDEO_FREEZING_ANSWER = "다음과 같은 몇 가지 방법을 시도해 볼 수 있습니다:\n\n1. 앱을 삭제하고 다시 설치하기\n\n2. 낮은 품질의 비디오로 전환하기. 연습을 시작한 후 일시 중지합니다. 오른쪽 상단의 <b>기어 아이콘</b>을 탭합니다. <b>비디오 품질</b>을 탭합니다. 더 높은 품질과 낮은 품질의 비디오 옵션을 볼 수 있어야 합니다. 이 설정은 요가 앱에서만 사용할 수 있습니다.\n\n3. 웹 전용: 다른 브라우저를 시도해 보세요. Down Dog는 Safari, Firefox, Chrome에서 가장 잘 작동합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1215
  override val VIDEO_FREEZING_QUESTION = "연습 도중 화면이 멈췄습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1201
  override val VIDEO_MODEL_ANSWER = "현재 각 앱마다 한명의 모델이 있습니다. Down Dog의 성장과 함께 더 많은 선택을 고객님께 제공할 수 있게 되기를 기원합니다!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1190
  override val VIDEO_MODEL_QUESTION = "영상에 나오는 모델을 변경할 수 있습니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=670
  override val VIDEO_QUALITY = "영상 퀄리티"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2558
  override val VIEW_OFFLINE_PRACTICE = "오프라인 실습 보기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1491
  override val VIEW_PLAYLIST_ANSWER = "수련 도중 또는 수련을 종료하신 후 <b> 히스토리 </b> 페이지에서 <b> 음악 </b>을 탭하면 수련 중에 재생된 음악 목록을 확인하실 수 있습니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1490
  override val VIEW_PLAYLIST_QUESTION = "수련 중에 재생된 음악은 무엇입니까?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3109
  override val VIEW_POSES = "포즈 보기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=75
  override val VISUAL_TYPE_NO_INTERNET_MESSAGE = "인터넷에 연결되어 있지 않습니다. 영상 타입을 변경 하려면 인터넷에 연결하십시오."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=290
  override val VOICE = "목소리"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2159
  override val VOICE_ACTOR_NON_ENGLISH_SURVEY_INTRO = "우리는 앱에 새로운 성우를 추가하고 있으며 여러분의 의견을 원합니다! 아래의 각 음성에 대해 1에서 5까지 점수를 매겨 마음에 드는 점을 알려주세요. 기술/음질 문제는 무시하고 실제 음성과 번역이 얼마나 자연스러운지에 집중하세요!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2154
  override val VOICE_ACTOR_SURVEY_INTRO = "우리는 앱에 새로운 성우를 추가하고 있으며 여러분의 의견을 원합니다! 아래의 목소리 중 가장 마음에 드는 목소리를 1부터 5까지 순위를 매겨 알려주세요. 기술/음질 문제를 용서하고 어떤 목소리가 마음에 드는지 알려주세요!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1423
  override val WANT_REFUND_CONFIRMATION = "이 결제를 환불 하시겠습니까? 귀하의 구독권이 취소되며 액세스 권한은 즉시 소멸됩니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1508
  override val WEEK_START_TITLE = "매주의 시작은 언제로 할까요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1518
  override val WEEKLY_GOAL = "주간 목표"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1504
  override val WEEKLY_GOAL_SELECTOR_TITLE = "주간 목표 설정하기"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1505
  override val WEEKLY_GOAL_SUBTITLE = "매주 몇 번의 수련을 목표로 하시나요?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=569
  override val WHATS_UP = "아래에 작성해 주세요."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1256
  override fun X_PERCENT_COMPLETE(p0: Any) = "${p0}% 완료"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=378
  override val YEARLY = "연간"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1289
  override val YEARLY_CAPITALIZED = "연간"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1731
  override val YES_SIGN_UP = "네, 회원가입합니다."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=291
  override val YES_STRING = "예"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1060
  override val YOGA = "요가"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=501
  override val YOGA_FOR_BEGINNERS = "진짜 초보를 위한 요가"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=757
  override val YOGA_GOOGLE_FIT_DESCRIPTION = "Down Dog 요가 수련"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1493
  override val YOGA_NIDRA_INFO_ANSWER = "요가 니드라는 깊이 이완하는 가이드 미디테이션입니다. 메인 요가 앱에서는 연습 <b>유형</b> 아래에서 찾을 수 있습니다.\n\n참고: <b>요가 니드라는 오디오 전용</b>입니다 - 비디오는 없습니다.\n\n많은 사람들이 앱에서 <b>음악</b>을 자연 소리, Ambient, 브레인 웨이브 또는 피아노와 현악으로 설정하는 것을 즐깁니다. 몇 가지를 시도해보고 어떤 것을 선호하는지 알아보세요!\n\n요가 니드라에 처음 접하는 경우, <b>지시 유형</b>을 <b>전체 설명</b> 또는 <b>기본</b>으로 설정하여 듣는 것을 추천합니다.\n\n또한 요가 니드라를 사용하여 잠들 수도 있습니다! 요가 니드라를 연습 유형으로 선택한 후, <b>부스트</b>로 이동하여 부스트를 <b>수면</b>으로 설정하세요!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1492
  override val YOGA_NIDRA_INFO_QUESTION = "요가 니드라는 무엇인가요?"
}
